<template>
  <div class="h-100">
    <breadCrumbs/>
    <template v-if="dataReady">
      <!--HEADER / MAIN INFO-->
      <div v-if="isTable(['orders']) || routePartOfOrdersGroup()" class="row mb-3">
        <div class="col-12 d-flex justify-content-end">
          <div v-for="(link, i) in externalLinks">
            <a :href="link.link" target="_blank">
              <button class="btn btn-sm btn-color-1 mx-1"
              >
                {{ link.name }}
              </button>
            </a>
          </div>

        </div>

        <div class="col-12">
          <div class="card border-0 shadow">
            <div class="card-header d-flex justify-content-between">
              <!--<h5> {{$t('orders.main')}} </h5>-->
              <button v-if="!saveButton" @click="editOrder" class="float_save_btn btn btn-sm d-none">
                <div><span class="icon icon-pencil icon-s"></span></div>
              </button>
              <button v-if="saveButton" class="float_confirm_save_btn btn btn-sm btn-success mx-1"
                      @click="orderSaveEdit(baseInfo)">
                {{ $t('orders.save') }}
              </button>
              <button v-if="saveButton" class="float_cancel_btn btn btn-sm btn-danger mx-1" @click="orderCancelEdit">
                {{ $t('message.cancel') }}
              </button>
              <!-- Created from -->
              <div v-if="(drafts && drafts[0] ) || baseInfo['createdFrom']" class="d-flex flex-row">
                <h5> {{ $t('orders.created_from') }} </h5>
                <div v-if="drafts[0]">
                  <a href="" @click="e => openDraft(e, drafts[0]['id'])">
                    <div class="mx-1 line-height-1">{{ drafts[0]['id'] }}</div>
                  </a>
                </div>
                <div v-else>
                  <a href="" @click="e => openDraft(e, baseInfo['createdFrom'])">
                    <div class="mx-1 line-height-1">{{ baseInfo['createdFrom'] }}</div>
                  </a>
                </div>

              </div>

              <!-- Billing Date -->
              <div class="d-flex flex-row" v-for="(it, index) in orderSchame" v-if="it.name === 'billingDate'"
              >
                <h5 class="text-danger">{{ $t('orders.billingDate') }} </h5> &nbsp;
                <div class="mx-1 line-height-1">{{ baseInfo['billingDate'] }}</div>
                <!-- Edit car number-->
                <formControl
                  ref="editOrder"
                  refInFor
                  type="text"
                  name="billingDate"
                  :val="baseInfo['billingDate']"
                  v-model="baseInfo['billingDate']"
                  class="d-none"
                />
              </div>

              <!-- Order Source -->
              <div class="d-flex flex-row">
                <h5> {{ $t('orders.orderSource') }} </h5>
                <div class="mx-1 line-height-1">{{ baseInfo['orderSource'] }}</div>
              </div>
              <!-- Last Update -->
              <div class="d-flex flex-row">
                <h5> {{ $t('orders.lastUpdate') }} </h5>
                <div class="mx-1 line-height-1">{{ baseInfo['updatedByUser_at'] }}</div>
              </div>

              <!-- Updated By -->
              <div class="d-flex flex-row">
                <h5> {{ $t('orders.updateBy') }} </h5>
                <div class="mx-1 line-height-1">{{ baseInfo['updatedByUserName'] }}</div>
              </div>

              <div class="">
                <button class="btn btn-sm btn-color-1 mx-1" @click="openOrderReplicatesModal">
                  גרסאות קודמות
                </button>
                <!-- Agency no-login order link session: hide drafts/related-orders (client request) -->
                <button v-if="!$store.getters.isAgencyLink" class="btn btn-sm btn-color-1 mx-1" @click="openDraftOrderModal">
                  טיוטות
                </button>
                <button v-if="!$store.getters.isAgencyLink && more_orders.length > 0" class="btn btn-sm btn-color-1 mx-1"
                        @click="openPopup">
                  ({{ more_orders.length }}) הזמנות קשורות
                </button>
                <button class="btn btn-sm btn-color-1 mx-1"
                        @click=" e => updateInsurance(e, 'order',baseInfo['ins_order'], baseInfo['ins-type'], baseInfo['license-number'], baseInfo['modeSource'])">
                  {{ $t('orders.editCompareDetails') }}
                </button>
                <button class="btn btn-sm btn-color-1 mx-1 d-none"
                        @click=" e => updateInsurance(e, 'insurance', baseInfo['ins_order']) ">
                  {{ $t('orders.editPolicyInfo') }}
                </button>

                <button v-if="!saveButton" class="btn btn-sm btn-color-1 mx-1 bg-color-2 border-color-2"
                        @click="editOrder">
                  {{ $t('orders.editOrder') }}
                </button>

                <button v-if="saveButton" class="btn btn-sm btn-success mx-1" @click="orderSaveEdit(baseInfo)">
                  {{ $t('orders.save') }}
                </button>
                <button v-if="saveButton" class="btn btn-sm btn-danger mx-1" @click="orderCancelEdit">
                  {{ $t('message.cancel') }}
                </button>

                <!-- Button Print -->
                <!--<button class="btn btn-sm btn-color-1 mx-1" @click="print()">Print</button>-->
                <!--<button class="btn btn-sm btn-color-1 mx-1">{{$t('orders.clonePolicy')}}</button>-->
                <!-- Agency no-login order link session: hide go-back (client request) -->
                <button v-if="!$store.getters.isAgencyLink" @click="$router.go(-1)" class="btn btn-link d-flex align-items-center">
                  {{ $t('message.goBack') }}
                  <span class="icon-arrowleft"></span>
                </button>
                <div v-if="isPopupOpen" class="popup">
                  <div class="popup-content card-body">
                    <div class="popup-header">
                      <h2>הזמנות אחרות</h2>
                      <button @click="closePopup" class="btn btn-color-1 btn-sm">סגור</button>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-sm mb-0">
                        <thead>
                        <tr>
                          <th class="font-weight-normal">שם</th>
                          <th class="font-weight-normal">זהות</th>
                          <th class="font-weight-normal">רישוי</th>
                          <th class="font-weight-normal">תחילה</th>
                          <th class="font-weight-normal">סטטוס</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(more_order, index) in more_orders" :key="index">
                          <td>{{ more_order['first-name'] }} {{ more_order['last-name'] }}</td>
                          <td>{{ more_order['identical-number'] }}</td>
                          <td>{{ more_order['license-number'] }}</td>
                          <td>{{ more_order['insurance-date-start'] }}</td>
                          <td>
                            <a :href="getLink(index)" target="_blank"
                               class="btn btn-link px-1" :style="getItemStyles(index)">
                              <span style="padding: 25px;">{{ more_order['status_name'] }}</span>
                            </a>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body row align-items-center">
              <div class="col-lg-2">
                <router-link :to="`view?table=clients&id=${baseInfo['customerId']}`">
                  <h2>{{ baseInfo['first-name'] }} {{ baseInfo['last-name'] }}</h2>
                </router-link>
                <div class="text-success">
                  {{
                    baseInfo['isCustomerExistsInCustomers'] ? $t('tables.headers.customerExists') :
                      $t('tables.headers.newCustomer')
                  }}
                </div>
              </div>

              <div class="col-lg-10">
                <div class="table-responsive">
                  <table class="table table-sm table-borderless mb-0">
                    <thead>
                    <tr>
                      <th class="font-weight-normal">{{ $t('orders.status') }}: <span
                        :style="{'color' : currentStatus['color']}">{{ currentStatus['value'] }}</span></th>
                      <th class="font-weight-normal">{{ $t('orders.type') }}</th>
                      <th class="font-weight-normal">{{ $t('orders.period') }}</th>
                      <th class="font-weight-normal">{{ $t('orders.insNum') }}</th>
                      <th class="font-weight-normal">{{ $t('orders.source') }}</th>
                      <th class="font-weight-normal">חדש/חידוש</th>
                      <th class="font-weight-normal">שירותי דרך</th>
                      <th class="font-weight-normal">חתימה / otp</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>
                        <!-- Order Status -->
                        <div class="input-group" v-if="!baseInfo['revision']">
                          <div v-if="isStatusChanged" class="input-group-prepend">
                            <button v-if="!isRenewalsSource" class="btn btn-color-3" type="button"
                                    @click="updateStatus('orderStatus')">
                              {{ $t('orders.update') }}
                            </button>
                            <button v-else class="btn btn-color-3" type="button"
                                    @click="updateStatus('renewalStatus')">
                              {{ $t('orders.update') }}
                            </button>
                          </div>
                          <label for="statuses" class="sr-only">
                            {{ $t('orders.statuses') }}
                          </label>
                          <select v-if="!isRenewalsSource" class="form-control" id="statuses" ref="orderStatus"
                                  v-model="statusColorIndex" @change="checkIfStatusChanged(true)">
                            <option v-for="option in options.statuses"
                                    :value="option.key"
                                    v-if="userAllowed(option.department)">
                              {{ option.value }}
                            </option>
                          </select>

                          <select v-else class="form-control" id="renewalStatus" ref="renewalStatus"
                                  v-model="renewalStatusColorIndex" @change="checkIfStatusChanged(true)">
                            <option v-for="option in options.renewalsStatus"
                                    :value="option.key"
                                    v-if="userAllowed(option.department)">
                              {{ option.value }}
                            </option>
                          </select>

                          <div class="input-group-append">
                                                        <span class="input-group-text"
                                                              :style="`backgroundColor:${statusColor};`"></span>
                          </div>
                        </div>

                        <div v-if="isRenewalsSource && baseInfo['renewalStatus'] !== '42'" class="mt-1">
                          <button class="btn btn-sm btn-primary" @click="transferToOrders('transfer')">
                            העברה להזמנות
                          </button>
                        </div>

                        <div v-if="isRenewalsSource && baseInfo['renewalStatus'] === '42'" class="mt-1">
                          <button class="btn btn-sm btn-danger" @click="transferToOrders('returnRenewal')">
                            החזר מהזמנות
                          </button>
                        </div>
                      </td>
                      <!-- Ins Type-->
                      <td>{{ translate(baseInfo['ins-type'], 'ins-type') }}</td>
                      <!-- Insurance date start/end -->
                      <td>{{ baseInfo['insurance-date-start'] }} {{ $t('orders.to') }}
                        {{ baseInfo['insurance-date-finish'] }}
                        <!--                        <div class="d-flex flex-row" v-for="(it, index) in orderSchame" v-if="it.name === 'insurance-date-start'">
                                                  <formControl
                                                    ref="editOrder"
                                                    refInFor
                                                     type="date"
                                                    name="license-number"
                                                    :val="baseInfo['insurance-date-start']"
                                                    :readOnly="it.readOnly"
                                                    v-model="baseInfo['insurance-date-start']"
                                                    class="d-none"
                                                    @input="onInput"
                                                  />


                                                </div>-->

                      </td>
                      <!-- Insurance Number -->
                      <td>{{ baseInfo['id'] }}</td>
                      <!-- Source -->
                      <td>{{ baseInfo['surfingSource'] }}</td>
                      <td>
                        <div class="d-flex align-self-center">
                          <span>{{ isRenewalOfExistingInsurance ? 'חידוש' : 'חדש' }}</span>
                          <input type="checkbox" v-model="isRenewalOfExistingInsurance" @click="updateIsRenewal()"
                                 class="mx-1">
                        </div>
                      </td>
                      <td>
                        <select class="form-control" id="roadServicesList" ref="roadServicesList"
                                v-model="roadServicesIndex" @change="updateRoadServices()">
                          <option value="">בחר שירות</option>
                          <option v-for="option in roadServicesList" :value="option.name">
                            {{ option.name }}
                          </option>
                        </select>
                      </td>

                      <td>
                        <div class="d-flex flex-row">
                         <div class="d-flex align-items-center">
                          <a v-if="baseInfo['isSignature'] === '1' && files[0]['url']" :href="files[0]['url']" target="_blank">
                            <span>חתימה:</span>
                          </a>
                          <span v-else>חתימה:</span>


                        <span :class="baseInfo['isSignature'] === '1'  ? 'text-success' : 'text-danger'">
                          {{ baseInfo['isSignature'] === '1' ? '✔' : '✖' }}
                        </span>
                      </div>
                      <div class="d-flex align-items-center">
                        <span class="mr-2">OTP:</span>
                        <span :class="baseInfo['isOtp'] === '1'  ? 'text-success' : 'text-danger'">
                          {{ baseInfo['isOtp'] === '1' ? '✔' : '✖' }}
                        </span>
                      </div>
                        </div>
                    </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="card-body row align-items-center" style="border-top: 1px solid rgba(0, 0, 0, 0.125);">
              <div class="col-lg-12">
                <div class="status-groups-filter">
                  <!-- Payment status -->
                  <div v-if="!baseInfo['revision']">
                    <div class="font-weight-normal">{{ $t('orders.paymentStatus') }}: <span
                      :style="{'color': currentStatusPayment.color}">
                        {{ currentStatusPayment.value }}
                      </span>
                    </div>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button class="btn btn-color-5" type="button"
                                @click="updateStatus('paymentStatus')">
                          {{ $t('orders.update') }}
                        </button>
                      </div>
                      <label for="paymentStatus"
                             class="sr-only">{{ $t('orders.paymentStatus') }}</label>
                      <select class="form-control" id="paymentStatus" ref="paymentStatus"
                              v-model="paymentStatusColorIndex">
                        <option v-for="option in options.paymentStatus"
                                :value="option.key">
                          {{ option.value }}
                        </option>
                      </select>
                      <div class="input-group-append">
                                            <span class="input-group-text"
                                                  :style="`backgroundColor:${paymentStatusColor};`"></span>
                      </div>
                    </div>
                  </div>

                  <!-- Policy status -->
                  <div v-if="!baseInfo['revision']">
                    <div class="font-weight-normal">{{ $t('orders.policyStatus') }}: <span
                      :style="{'color': currentStatusPolicy.color}">
                        {{ currentStatusPolicy.value }}
                      </span>
                    </div>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button class="btn btn-color-5" type="button"
                                @click="updateStatus('policyStatus')">
                          {{ $t('orders.update') }}
                        </button>
                      </div>
                      <label for="policyStatus"
                             class="sr-only">{{ $t('orders.policyStatus') }}</label>
                      <select class="form-control" id="policyStatus" ref="policyStatus"
                              v-model="policyStatusColorIndex">
                        <option v-for="option in options.policyStatus"
                                :value="option.key">
                          {{ option.value }}
                        </option>
                      </select>
                      <div class="input-group-append">
                                            <span class="input-group-text"
                                                  :style="`backgroundColor:${policyStatusColor};`"></span>
                      </div>
                    </div>
                  </div>

                  <!-- Change status -->
                  <div v-if="!baseInfo['revision']">
                    <div class="font-weight-normal">{{ $t('orders.changesStatus') }}: <span
                      :style="{'color': currentStatusChange.color}">
                        {{ currentStatusChange.value }}
                      </span>
                    </div>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button class="btn btn-color-5" type="button"
                                @click="updateStatus('changesStatus')">
                          {{ $t('orders.update') }}
                        </button>
                      </div>
                      <label for="changesStatus"
                             class="sr-only">{{ $t('orders.changesStatus') }}</label>
                      <select class="form-control" id="changesStatus" ref="changesStatus"
                              v-model="changesStatusColorIndex">
                        <option v-for="option in options.changesStatus"
                                :value="option.key">
                          {{ option.value }}
                        </option>
                      </select>
                      <div class="input-group-append">
                                            <span class="input-group-text"
                                                  :style="`backgroundColor:${changesStatusColor};`"></span>
                      </div>
                    </div>
                  </div>

                  <!-- Policy status -->
                  <div v-if="!baseInfo['revision']">
                    <div class="font-weight-normal">{{ $t('orders.claimsStatus') }}: <span
                      :style="{'color': currentStatusClaims.color}">
                        {{ currentStatusClaims.value }}
                      </span>
                    </div>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button class="btn btn-color-5" type="button"
                                @click="updateStatus('claimsStatus')">
                          {{ $t('orders.update') }}
                        </button>
                      </div>
                      <label for="claimsStatus"
                             class="sr-only">{{ $t('orders.claimsStatus') }}</label>
                      <select class="form-control" id="claimsStatus" ref="claimsStatus"
                              v-model="claimsStatusColorIndex">
                        <option v-for="option in options.claimsStatus"
                                :value="option.key">
                          {{ option.value }}
                        </option>
                      </select>
                      <div class="input-group-append">
                                            <span class="input-group-text"
                                                  :style="`backgroundColor:${claimsStatusColor};`"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="row mb-3">
        <div class="col-lg-12">
          <div class="bg-white rounded p-3 shadow d-flex align-items-center justify-content-between">
            <div>
              <span
                class="h1 text-color-1 d-block mb-0">עדכן {{ this.config.singleTableNameHe }} מספר {{
                  $route.query.id
                }} </span>
            </div>

            <div v-if="isTable(['leads', 'calculator'])">
              <a v-if="baseInfo['source']" :href="`${baseInfo['source'].startsWith('http') ? '' : 'https://'}${baseInfo['source']}&ai=${$store.getters.userId}`"
                 target="_blank"
                 class="btn btn-link px-1">
                <span>למעבר להזמנה</span>
              </a>
            </div>

            <!-- Agency no-login order link session: hide go-back (client request) -->
            <div v-if="!$store.getters.isAgencyLink">
              <button @click="$router.go(-1)" class="btn btn-link d-flex align-items-center">
                {{ $t('message.goBack') }}
                <span class="icon-arrowleft"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--EDIT Table FIELDS-->
      <div
        v-if="isTable(['leads', 'calculator', 'departments', 'messages', 'users', 'statuses', 'tasks', 'clients', 'renewals', 'whatsappCampaign', 'smsCampaign','mailCampaign'])"
        class="row mb-3">
        <div class="col-lg-12">
          <div class="bg-white rounded p-3 shadow d-flex align-items-center justify-content-between">
            <!-- Messages Template - Use custom message form in edit mode -->
            <messageForm v-if="isTable(['messages'])"
                         mode="edit"
                         :baseInfo="baseInfo"
                         :options="options"
                         @updateMessage="(data) => updateMessageData(data)"
            />

            <!-- Default form for other tables -->
            <form v-else @submit.prevent="validateForm('mainForm', baseInfo['statusId'])" data-vv-scope="mainForm"
                  class="d-flex flex-wrap"
                  autocomplete="off">
              <div :class="isTable(['smsCampaign']) ? 'col-12' : 'col-4'" v-for="(item, i) in config.schema">
                <formControl :label="$t('tables.headers.' + item.name)"
                             :type="item.type"
                             :id="`${item.name}_${i}`"
                             :name="item.name"
                             v-validate="item.validation"
                             :error="errors.first('mainForm.' + item.name)"
                             :options="options[item.options] ? options[item.options] : item.options"
                             :val="baseInfo[item.name]"
                             v-model="mainForm[item.name]"
                             :maxlength="item.name === 'smsContent' ? '130' : ''"
                             :rows="'5'"
                />
                <span v-if="item.name === 'phone' && isTable(['leads'])" style=" position: absolute; top: 0; left: 57%"
                      @click="handleUserWhatsapp(baseInfo['phone'], baseInfo['fullName'], 'leads')">
                  <span class="cursor-pointer"><img src="assets/images/whatsapp.png"> </span>
                </span>
                <div v-if="item.type === 'textarea' && isTable(['calculator'])" id="cleanTextArea" v-html></div>

                <span class="pull-left" v-if="item.name === 'smsContent' ">
                    {{ mainForm[item.name] ? mainForm[item.name].length : '' }}
                 </span>
              </div>
              <div class="col-lg-4 d-flex align-items-end mb-2">
                <button type="submit" class="btn btn-color-1 w-100">
                  <span>Edit</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--4 COLUMNS-->
      <div v-if="isTable(['orders']) || routePartOfOrdersGroup()" class="row">
        <div class="col-lg-3 mb-3">
          <div class="card h-100 border-0 shadow">
            <!-- Car Number -->
            <div class="td-wrapper card-header" v-for="(it, index) in orderSchame" v-if="it.name === 'license-number'"
            >
              <span>{{ $t('orders.carNum') }} </span> &nbsp;
              <span class="font-weight-bold">{{ baseInfo['license-number'] }}</span>
              <a v-if="baseInfo['license-number']"
                 :href="`https://mail.google.com/mail/u/0/#search/סיכום ההזמנה שלך - ${id} - מספר רכב ${baseInfo['license-number']}`"
                 target="_blank"
                 class="btn btn-link px-1">
                <img src="https://www.hova.co.il/wp-content/uploads/2023/07/Gmail_Icon-e1688551667245.png"/>
              </a>

              <button class="btn btn-info pull-left" @click="carMoreInfo(baseInfo['license-number'])">למידע נוסף
              </button>

              <!-- Edit car number-->
              <formControl
                ref="editOrder"
                refInFor
                type="text"
                name="license-number"
                :val="baseInfo['license-number']"
                :readOnly="it.readOnly"
                v-model="baseInfo['license-number']"
                class="d-none"
              />
            </div>

            <!-- Car details -->
            <div class="card-body bvb">
              <div v-for="(it, index) in orders.carNew" v-if="baseInfo['ins-type'] !== '2' && baseInfo.hasOwnProperty(it.name)">
                <div class="td-wrapper">
                  <span>{{ $t('tables.headers.' + it.name) }}: </span> &nbsp;
                  <span v-if="it.name === 'ownership' && baseInfo['ownership'] === 'חברה'"
                        class="btn btn-sm btn-danger">{{ translate(baseInfo[it.name], it.name) }} </span>
                  <span v-else>
                  <span v-if=" it.name != 'license-number-go'" class="font-weight-bold">{{ translate(baseInfo[it.name], it.name) }}</span>
                </span>

                  <formControl
                    ref="editOrder"
                    refInFor
                    :type="it.type"
                    :name="it.name"
                    :val="translate(baseInfo[it.name], index)"
                    :options="it.options"
                    :readOnly="it.readOnly"
                    v-model="baseInfo[it.name]"
                    class="d-none"
                  />

                </div>

              </div>
              <div v-for="i in orders.carMakif" v-if="baseInfo['ins-type'] === '2' && baseInfo.hasOwnProperty(i)">
                <span>{{ $t('tables.headers.' + i) }}: </span> &nbsp;
                <span class="font-weight-bold" v-if=" i != 'license-number-go'">{{ translate(baseInfo[i], i) }}</span>
              </div>


              <!-- Handling protectiveStatus -->
              <div v-if="!baseInfo['revision']">
                <div class="font-weight-normal pt-4">{{ $t('orders.protectiveStatus') }}:
                  <span
                    :style="{'color' : currentProtectiveStatus.color}">
                   {{ currentProtectiveStatus.value }}
                </span>
                </div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <button class="btn btn-color-5" type="button"
                            @click="updateStatus('protectiveStatus')">
                      {{ $t('orders.update') }}
                    </button>
                  </div>
                  <label for="protectiveStatus"
                         class="sr-only">{{ $t('orders.protectiveStatus') }}</label>
                  <select class="form-control" id="protectiveStatus" ref="protectiveStatus"
                          v-model="protectionStatusColorIndex">
                    <option v-for="option in options.protectionStatus"
                            :value="option.key">
                      {{ option.value }}
                    </option>
                  </select>
                  <div class="input-group-append">
                                    <span class="input-group-text"
                                          :style="`backgroundColor:${protectionStatus};`"></span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Drivers and history insurance-->
        <div class="col-lg-3 mb-3">
          <div class="card h-100 border-0 shadow">
            <h5 class="card-header">{{ $t('orders.insuranceHistory') }}</h5>
            <div class="card-body">
              <div v-for="(item, i) in baseInfo">
                <div class="td-wrapper" v-for="(it, index) in orders.driverLawNew" v-if="i === it.name ">
                  <span>{{ $t('tables.headers.' + i) }}: </span> &nbsp;

                  <span v-if="i === 'drive-on-saturday' && baseInfo['drive-on-saturday'] === '0' ||
                        i === 'license-suspensions' && baseInfo['license-suspensions'] === '1' ||
                        i === 'body-claims' && baseInfo['body-claims'] === '1'
                        "
                        class="btn btn-sm btn-danger">{{ translate(item, i) }}
                  </span>
                  <span v-else class="font-weight-bold">{{ translate(item, i) }}</span>

                  <formControl
                    ref="editOrder"
                    refInFor
                    :type="it.type"
                    :name="it.name"
                    :val="translate(item, index)"
                    :options="it.options"
                    :readOnly="it.readOnly"
                    v-model="baseInfo[it.name]"
                    class="d-none"
                  />

                </div>
              </div>
              <!-- Insurance History Insurance-->
              <h3><u>{{ $t('orders.insuranceHistory') }}</u></h3>
              <div v-for="(item, i) in baseInfo">
                <div class="td-wrapper" v-for="(it, index) in orders.driverHistoryNew" v-if="i === it.name">
                  <!-- Ownership Date-->
                  <span v-if="i === 'ownership-date' "> {{ $t('tables.headers.' + i) }}:
                   <span class="font-weight-bold">
                     {{ baseInfo['ownership-date'] == '1' ? $t('orders.underAYear') : $t('orders.overAYear') }}
                   </span>
                </span>
                  <!-- Ownership Under Year -->
                  <span v-if="i === 'ownership-under-year' "> {{ $t('tables.headers.' + i) }}:
                   <span class="font-weight-bold">
                     {{ baseInfo['ownership-under-year'] }}
                   </span>
                </span>

                  <!-- Insurance Before-->
                  <div v-if="i === 'insurance-before'"> {{ $t('tables.headers.' + i) }}:
                    <span class="font-weight-bold">
                     {{ baseInfo['insurance-before'] == '1' ? $t('orders.yes') : $t('orders.no') }}
                   </span>
                  </div>

                  <!-- Law suites 3 year -->
                  <div v-if="i === 'law-suites-3-year'"> {{ $t('tables.headers.' + i) }}:
                    <span class="font-weight-bold">

                      <span
                        v-if="baseInfo['law-suites-3-year'] === '0' || !baseInfo['law-suites-3-year']">{{ $t('orders.no') }}</span>
                    <span v-else class="btn btn-danger">{{ $t('orders.yes') }}</span>

                      <!--                     {{ baseInfo['law-suites-3-year'] == '1' ? $t('orders.yes') : $t('orders.no') }}-->
                   </span>
                    <div v-if="baseInfo['law-suites-3-year'] === '1'">
                    <span class="font-weight-bold"
                          v-if="baseInfo['law-suite-what-year'] === '1'"> {{
                        $t('tables.headers.insurance-1-year')
                      }}</span>
                      <span class="font-weight-bold"
                            v-if="baseInfo['law-suite-what-year'] === '2'"> {{
                          $t('tables.headers.insurance-2-year')
                        }}</span>
                      <span class="font-weight-bold"
                            v-if="baseInfo['law-suite-what-year'] === '3'"> {{
                          $t('tables.headers.insurance-3-year')
                        }}</span>
                    </div>
                  </div>

                  <!-- TODO:: make the code more readable-->
                  <div v-if="baseInfo['insurance-before'] == '1' && i != 'insurance-before'
                            && i != 'ownership-date' && i !== 'ownership-under-year' && i !== 'law-suites-3-year'">
                    {{ $t('tables.headers.' + i) }}:
                    <!--                    <span class="font-weight-bold" v-if="item == '1'"> {{ $t('orders.mekif') }}</span>
                                        <span class="font-weight-bold" v-if="item == '2'"> {{ $t('orders.zadGimel') }}</span>
                                        <span class="font-weight-bold" v-if="item == '3'"> {{ $t('orders.noInsurance') }}</span>-->

                    <span class="font-weight-bold"> {{ translate(item, 'insurance-1-year') }}</span>
                  </div>


                  <formControl
                    v-if="it.name !=='insurance-1-year' && it.name !=='insurance-2-year' && it.name !=='insurance-3-year'"
                    ref="editOrder"
                    refInFor
                    :type="it.type"
                    :name="it.name"
                    :val="baseInfo[it.name]"
                    :options="it.options"
                    :readOnly="it.readOnly"
                    v-model="baseInfo[it.name]"
                    class="d-none"
                  />

                  <formControl
                    v-if="(it.name ==='insurance-1-year' || it.name ==='insurance-2-year' || it.name ==='insurance-3-year') && shouldShowInsuranceField(it.name) && saveButton"
                    ref="editOrder"
                    refInFor
                    :type="it.type"
                    :name="it.name"
                    :val="baseInfo[it.name]"
                    :options="it.options"
                    :readOnly="it.readOnly"
                    v-model="baseInfo[it.name]"

                  />

                </div>
              </div>
              <br>

              <!-- Lack of claims status -->
              <div v-if="!baseInfo['revision']">
                <div class="font-weight-normal">{{ $t('orders.lackOfClaims') }}: <span
                  :style="{'color': currentStatusLackOfClaims.color}">
                {{ currentStatusLackOfClaims.value }}
              </span>
                </div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <button class="btn btn-color-5" type="button"
                            @click="updateStatus('lackOfClaimsStatus')">
                      {{ $t('orders.update') }}
                    </button>
                  </div>
                  <label for="lackOfClaimsStatus"
                         class="sr-only">{{ $t('orders.lackOfClaims') }}</label>
                  <select class="form-control" id="lackOfClaimsStatus" ref="lackOfClaimsStatus"
                          v-model="lackOfClaimsColorIndex">
                    <option v-for="option in options.lackOfClaims"
                            :value="option.key">
                      {{ option.value }}
                    </option>
                  </select>
                  <div class="input-group-append">
                                    <span class="input-group-text"
                                          :style="`backgroundColor:${lackOfClaimsColor};`"></span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Policy Owner Info -->
        <div class="col-lg-3 mb-3">
          <div class="card h-100 border-0 shadow">
            <div class="card-header d-flex justify-content-between">
              <h5>{{ $t('orders.policyOwner') }} - {{
                  baseInfo['drive-allowed'] == '1' ? $t('orders.driveInCar') :
                    $t('orders.notDriveInCar')
                }}</h5>
              <router-link :to="`view?table=clients&id=${baseInfo['customerId']}`" class="btn btn-color-1 btn-sm">
                {{ $t('orders.moreInfo') }}
              </router-link>
            </div>
            <div class="card-body">
              <div v-for="(item, i) in baseInfo" v-if="orders.driver.includes(i)">
                <div class="td-wrapper" v-for="(it, index) in orderSchame" v-if="i === it.name">

                  <span>{{ $t('tables.headers.' + i) }}: </span> &nbsp;
                  <span class="font-weight-bold" :class="i == 'identical-number'? 'blue-text': ''" v-if="i != 'email'">{{
                      translate(item, i)
                    }}</span>


                  <span class="font-weight-bold cursor-pointer " v-if="i === 'email'"
                        @click="openMail(baseInfo['email'], baseInfo['first-name'], baseInfo['last-name'], baseInfo['license-number'])">{{
                      translate(item, i)
                    }}</span>

                  <span v-if="i === 'mobile-phone-number'" class="cursor-pointer btn btn-link px-1"
                        @click="handleUserWhatsapp(baseInfo['mobile-phone-number'], baseInfo['first-name'],  baseInfo['last-name'])">
                     <img src="https://www.hova.co.il/wp-content/uploads/2023/06/whatsapp-1.png"/>
                  </span>
                  <!--                  <a v-if="i === 'mobile-phone-number'" :href="`https://chatboxx.me/chat/phone/${translate(item, i)}`"-->
                  <!--                     target="_blank"-->
                  <!--                     class="btn btn-link px-1">-->
                  <!--                    <img src="https://www.hova.co.il/wp-content/uploads/2023/06/whatsapp-1.png"/>-->
                  <!--                  </a>-->
                  <!-- Update insurance owner -->
                  <formControl
                    ref="editOrder"
                    refInFor
                    :type="it.type"
                    :name="it.name"
                    :val="item.toString()"
                    :options="it.options"
                    :readOnly="it.readOnly"
                    v-model="baseInfo[it.name]"
                    class="d-none"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 mb-3">
          <div class="card h-100 border-0 shadow">
            <h5 class="card-header">{{ $t('orders.drivers') }}</h5>
            <div class="card-body">
              <div v-for="(item, i) in baseInfo"
                   v-if="orders.driver_1.includes(i) && baseInfo['firstDriverGender'].length > 0">

                <div class="td-wrapper" v-for="(it, index) in orderSchame" v-if="i === it.name">
                  <span>{{ $t('tables.headers.' + i) }}: </span>
                  <span class="font-weight-bold">{{ translate(item, i) }}</span>
                  <!-- Update firstDriver -->
                  <formControl
                    ref="editOrder"
                    refInFor
                    :type="it.type"
                    :name="it.name"
                    :val="translate(item, index).toString()"
                    :options="it.options"
                    :readOnly="it.readOnly"
                    v-model="baseInfo[it.name]"
                    class="d-none"
                  />
                </div>

              </div>
              <br>
              <!-- Driver 2 Info -->
              <div v-for="(item, i) in baseInfo"
                   v-if="orders.driver_2.includes(i) && baseInfo['secondDriverGender'].length > 0">

                <div class="td-wrapper" v-for="(it, index) in orderSchame" v-if="i === it.name">

                  <span>{{ $t('tables.headers.' + i) }}: </span> &nbsp;
                  <span class="font-weight-bold">{{ translate(item, i) }}</span>

                  <!-- Update secondDriver -->
                  <formControl
                    ref="editOrder"
                    refInFor
                    :type="it.type"
                    :name="it.name"
                    :val="translate(item, index).toString()"
                    :options="it.options"
                    :readOnly="it.readOnly"
                    v-model="baseInfo[it.name]"
                    class="d-none"
                  />
                </div>
              </div>
              <br>
              <!-- Driver 3 Info -->
              <div v-for="(item, i) in baseInfo"
                   v-if="orders.driver_3.includes(i) && baseInfo['thirdDriverFirstName'].length > 0">
                <div class="td-wrapper" v-for="(it, index) in orderSchame" v-if="i === it.name">

                  <span>{{ $t('tables.headers.' + i) }}: </span> &nbsp;
                  <span class="font-weight-bold">{{ translate(item, i) }}</span>

                  <!-- Update thirdDriver -->
                  <formControl
                    ref="editOrder"
                    refInFor
                    :type="it.type"
                    :name="it.name"
                    :val="translate(item, index)"
                    :options="it.options"
                    :readOnly="it.readOnly"
                    v-model="baseInfo[it.name]"
                    class="d-none"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="baseInfo['mortgaged'] === '1'">
        <div class="col-3" v-if="baseInfo['mortgagedName']">
          <p class="btn-danger text-center py-1"><span>שעבוד לטובת: </span><span>{{ baseInfo['mortgagedName'] }}</span>,
            <span>{{ baseInfo['mortgagedAddress'] }}</span></p>
        </div>
        <div class="col-3" v-if="baseInfo['isMortgagedCheckbox'] === 'true'">
          <p class="btn-danger text-center py-1">אין צורך בסעיף שיעבוד בפוליסה</p>
        </div>
      </div>
      <!--ALT ADDRESS-->
      <div v-if="(isTable(['orders']) || routePartOfOrdersGroup()) && baseInfo['use-another-address']" class="row mb-3">
        <div class="col-12">
          <div class="card border-0 shadow mb-3">
            <h5 class="card-header">{{ $t('orders.driverAltAddress') }}</h5>
            <div class="card-body">
              <span>{{ $t('orders.city') }}:</span><span class="font-weight-bold">{{ baseInfo['city-another'] }}</span>
              &nbsp;
              <span>{{ $t('orders.street') }}:</span><span
              class="font-weight-bold">{{ baseInfo['street-another'] }}</span>
              &nbsp;
              <span>{{ $t('orders.houseNum') }}:</span><span
              class="font-weight-bold">{{ baseInfo['house-number-another'] }}</span>
              &nbsp;
              <span>{{ $t('orders.aptNum') }}:</span><span
              class="font-weight-bold">{{ baseInfo['apartment-number-another'] }}</span>
            </div>
          </div>
        </div>
      </div>


      <!--PRODUCTS-->
      <div v-if="(isTable(['orders']) || routePartOfOrdersGroup()) && !baseInfo['replicate']" class="row mb-3">
        <div class="col-12">
          <div class="card border-0 shadow">
            <div class="card-header d-flex justify-content-between">
              <h5> {{ $t('orders.products') }} </h5>
              <div class="d-flex flex-row">
                <button class="btn btn-color-1 btn-sm" type="button" data-toggle="collapse"
                        data-target="#collapseProduct" aria-expanded="false"
                        aria-controls="collapseProduct">{{ $t('orders.addNewProduct') }}
                </button>
              </div>
            </div>

            <div class="card-body">
              <!-- add new product -->
              <div class="row">
                <div class="col-lg-12">

                  <form @submit.prevent="e => addNewProduct(e)" class="collapse mb-2" id="collapseProduct">
                    <div class="d-flex">
                      <select v-model="selectedProduct" class="form-control">
                        <option disabled value="">מוצר</option>
                        <option v-for="product in uniqueProducts" :key="product">{{ product }}</option>
                      </select>
                      <select v-model="selectedCompany" class="form-control">
                        <option disabled value="">חברה</option>
                        <option v-for="company in filteredCompanies" :key="company">{{ company }}</option>
                      </select>
                      <select v-model="selectedDescription" class="form-control">
                        <option disabled value="">תיאור</option>
                        <option v-for="description in filteredDescriptions" :key="description">{{
                            description
                          }}
                        </option>
                      </select>
                    </div>
                    <div>

                      <div v-if="selectedDescription && productSelectedRow">

                        <div class="d-flex   align-items-center mb-2">
                          <div class="d-flex align-items-center mx-1">
                            <span class="me-1 mx-1">התחלה:</span>
                            <input
                              type="text"
                              v-model="baseInfo['insurance-date-start']"
                              class="form-control"
                              required
                              style="width: 110px;"/>
                          </div>

                          <div class="d-flex align-items-center mx-1">
                            <span class="me-1 mx-1">סיום:</span>
                            <input
                              type="text"
                              v-model="baseInfo['insurance-date-finish']"
                              class="form-control"
                              required
                              style="width: 110px;"/>
                          </div>

                          <div class="d-flex align-items-center mx-1"
                               v-if="productSelectedRow.productName === 'צד ג' || productSelectedRow.productName === 'מקיף'">
                            <span class="me-1 mx-1">ה.עצמית:</span>
                            <input
                              type="text"
                              v-model="productSelectedRow.deductible"
                              class="form-control"
                              :required="productSelectedRow.productName === 'צד ג' || productSelectedRow.productName === 'מקיף'"
                              style="width: 100px;"/>
                          </div>

                          <div class="d-flex align-items-center mx-1" v-if="productSelectedRow.productName === 'מקיף'">
                            <span class="me-1 mx-1">ה.ע בהסדר:</span>
                            <input
                              type="text"
                              v-model="productSelectedRow.debtSettlement"
                              class="form-control"
                              :required="productSelectedRow.productName === 'צד ג' || productSelectedRow.productName === 'מקיף'"
                              style="width: 100px;"/>
                          </div>

                          <div class="d-flex align-items-center mx-1" v-if=" productSelectedRow.productName === 'מקיף'">
                            <span class="me-1 mx-1">גבול אחריות:</span>
                            <input
                              type="text"
                              v-model="productSelectedRow.zadGimelRes"
                              class="form-control"
                              :required="productSelectedRow.productName === 'מקיף'"
                              style="width: 100px;"/>
                          </div>

                          <div class="d-flex align-items-center mx-1">
                            <span class="me-1 mx-1">מחיר:</span>
                            <input
                              type="number"
                              v-model="productSelectedRow.price"
                              class="form-control  "
                              style="width: 100px;"/>
                          </div>

                          <div class="d-flex align-items-center mx-1">
                            <span class="me-1 mx-1">תשלומים:</span>
                            <select
                              v-model="productSelectedRow.selectedInstallment"
                              class="form-control "
                              style="width: 140px;">
                              <option
                                v-for="n in productSelectedRow.maxPay"
                                :key="n"
                                :value="n">
                                {{
                                  n
                                }}{{ n > productSelectedRow.maxInterestFreeInstallments ? ' (בתוספת דמי אשראי)' : '' }}
                              </option>
                            </select>
                          </div>


                          <div class="d-flex align-items-center ">
                            <div class="d-flex align-items-center mx-1">
                              <span class="me-1 mx-1">{{ $t('tables.headers.policyNumber') }}:</span>
                              <input
                                type="text"
                                v-model="productSelectedRow.policyNumber"
                                class="form-control"
                                style="width: 150px;"
                              />
                            </div>
                            <div class="d-flex align-items-center mx-1">
                              <span class="me-1 mx-1">{{ $t('tables.headers.note') }}:</span>
                              <input
                                type="text"
                                v-model="productSelectedRow.comments"
                                class="form-control"
                                style="width: 200px;"

                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <button type="submit" class="btn btn-color-1" v-if="selectedDescription && productSelectedRow">
                      {{ $t('orders.save') }}
                    </button>
                  </form>


                </div>
              </div>

              <div class="table-responsive">
                <!-- Show products list -->
                <table class="table table-sm mb-0">
                  <thead>
                  <tr>
                    <th></th>
                    <th class="font-weight-normal" v-for="(item, i) in config.productsSchema"
                        v-if="item.name !== 'updated_at' && item.name !== 'created_at' && item.name !== 'id' && item.name !== 'orderId' && item.name !== 'description'">
                      {{ $t('tables.headers.' + item.name) }}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(product, k) in products">
                    <td>
                      <div class="d-flex ">
                        <template v-if="inRowEdit === k" class="d-flex">
                          <button class="btn btn-sm btn-color-1 rounded-0 w-75" @click="doneEdit(product, k)">
                            <span>{{ $t('message.update') }}</span>
                          </button>
                          <button class="btn btn-sm btn-color-6 rounded-0 w-75" @click="cancelEdit(k)">
                            <span>{{ $t('message.clean') }}</span>
                          </button>
                        </template>
                        <template v-else>
                          <button class="btn btn-link px-1" @click="editProduct(product, k)"><span
                            class="icon icon-pencil icon-xs"></span></button>
                          <button class="btn btn-link px-1" @click="showProductHistory(product, k)"><span
                            class="icon icon-eye icon-xs"></span></button>
                          <button class="btn btn-link px-1" @click="showDescription(product.description)"
                                  v-if="product.description"><i class="fa fa-info"></i></button>
                        </template>
                      </div>
                    </td>


                    <td v-for="(item, i) in config.productsSchema"
                        v-if="item.name !== 'updated_at' && item.name !== 'created_at' &&
                         item.name !== 'id' && item.name !== 'orderId' && item.name !== 'description'"
                        :title="item.name === 'numberOfPayment' ? getMonthlyPayment(product) : ''"
                        :style="item.name === 'numberOfPayment' ? 'cursor: help;' : ''"
                        :key="item.name">

                      <div class="td-wrapper" :ref="k+'_'+item.name"
                           v-if="!(inRowEdit === k && item.name === 'userName')">
                        <div v-if="item.name === 'statusId'">
                          <span v-if="product[item.name] === 2"
                                class="text-danger font-weight-bold"> {{
                              translate(product[item.name], item.name)
                            }}</span>
                          <span v-if="product[item.name] === 1"
                                class="text-black"> {{ translate(product[item.name], item.name) }}</span>
                        </div>
                        <span v-if="item.name !== 'statusId'">{{ translate(product[item.name], item.name) }}</span>
                        <!-- Debug: {{ item.name }} -->
                      </div>

                      <formControl
                        v-if="!(inRowEdit === k && item.name === 'userName')"
                        :ref="`form_${k}_${item.name}`"
                        :type="item.name === 'comments' ? 'textarea' : item.type"
                        :name="'product[item.name]'"
                        :val="product[item.name]"
                        :options="productsStatuses"
                        :rows="item.name === 'comments' ? '3' : '1'"
                        v-model="product[item.name]"
                        class="d-none"
                        :style="item.name === 'comments' ? 'width: 300px;' : item.name === 'price' || item.name === 'deductible' || item.name === 'debtSettlement' || item.name === 'zadGimelRes' ? 'width: 120px;' : item.name === 'numberOfPayment' ? 'width: 80px;' : 'width: 150px;'"
                        :readOnly="(item.name === 'debtSettlement' && product.productName === 'צד ג') || ((item.name === 'debtSettlement' || item.name === 'zadGimelRes' || item.name === 'deductible') && product.productName !== 'מקיף' && product.productName !== 'צד ג')"
                      />


                      <!--<input type="text" class="form-control mb-0 d-none" v-model="products[k][i]">-->
                    </td>
                  </tr>

                  </tbody>
                  <tfoot>
                  <tr>
                    <td></td>
                    <td v-for="(product, i) in products[0]"
                        v-if="i !== 'updated_at' && i !== 'created_at' && i !== 'id' && i !== 'productFile' && i !== 'orderId' && i !== 'costPerMount'"
                        :key="i">
                      <strong v-if="i === 'price'">
                        {{ getTotalPrice() }} ₪
                      </strong>

                      <span v-else>-</span>
                    </td>
                  </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Card Order Info -->
      <div v-if="(isTable(['orders', 'leads', 'calculator']) || routePartOfOrdersGroup()) && !baseInfo['replicate']"
           class="row mb-3">
        <div class="col-12">
          <div class="card border-0 shadow">
            <div class="card-header d-flex justify-content-between">
              <div>
                <h5 class="d-inline ml-1"> {{ $t('orders.cardHolderInfo') }} </h5>

                <div class="d-inline" v-if="$store.getters.isCcShow && baseInfo['card-owner-token']">
                  <button class="btn btn-color-1 btn-sm" type="button"
                          aria-controls="collapseProduct" @click="getCreditDetails(baseInfo['card-owner-token'])">
                    {{ $t('orders.showCreditDetails') }}
                  </button>
                  <button v-if="!$store.getters.isAgencyLink" class="btn btn-color-1 btn-sm mr-2" type="button" aria-controls="collapseProduct"
                          @click="getCreditDecrypt(baseInfo['card-owner-token'],baseInfo['card-owner-key'])">
                    הצג אשראי זמני
                  </button>
                </div>
                <button v-if="!$store.getters.isAgencyLink" type="button" class="btn btn-color-1 btn-sm mr-2" data-toggle="modal"
                        @click="orderNewCredit($route.query.id)" data-target="#newCardDetails">הכנס כרטיס אשראי חדש
                </button>

                <div class="modal fade" id="newCardDetails" role="dialog"> <!-- kobi -->
                  <div class="modal-dialog">

                    <div class="modal-content">
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title">פרטי כרטיס אשראי</h4>
                      </div>
                      <div class="modal-body">
                        <iframe v-if="newCreditIframeUrl" style="width: 80%; margin:0 auto; min-height: 600px;border:0"
                                :src="newCreditIframeUrl"></iframe>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">סגור</button>
                      </div>
                    </div>

                  </div>
                </div>

                <div v-if="creditShowVal" class="d-inline mx-1">{{ creditShowVal }}</div>
                <div v-if="tokenErrorMsg" class="d-inline mx-1">{{ tokenErrorMsg }}</div>
              </div>
              <div class="row" v-if="$store.getters.isCcShow">
                <div class="col-3">
                  <button class="btn btn-danger btn-sm" type="button"
                          aria-controls="collapseProduct" @click="removeCreditNumber($route.query.id)">
                    {{ $t('orders.remove') }}
                  </button>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row card-info">
                    <div class="col-2">
                      <formControl :label="$t('orders.cardHolderName')"
                                   type="text"
                                   name="cardHolderName"
                                   class="mb-2"
                                   v-validate="'required'"
                                   :val="baseInfo['cardholder-name']"
                                   v-model="baseInfo['cardholder-name']"
                                   :readOnly="isCreditUpdate"
                      />
                    </div>
                    <div class="col-2">
                      <formControl :label="$t('tables.headers.identical-number')"
                                   type="text"
                                   name="identicalNumber"
                                   class="mb-2"
                                   v-validate="'required'"
                                   :val="baseInfo['cardholder-id']"
                                   v-model="baseInfo['cardholder-id']"
                                   :readOnly="isCreditUpdate"
                      />
                    </div>
                    <div class="col-2">
                      <formControl :label="$t('orders.cardHolderPhone')"
                                   type="text"
                                   name="cardHolderPhone"
                                   class="mb-2"
                                   v-validate="'required'"
                                   :val="baseInfo['cardholder_phone']"
                                   v-model="baseInfo['cardholder_phone']"
                                   :readOnly="isCreditUpdate"
                      />
                    </div>
                    <div class="col-3">
                      <formControl :label="$t('orders.cardNumber')"
                                   type="text"
                                   name="cardNumber"
                                   class="ltr mb-2"
                                   v-validate="'required'"
                                   :val="baseInfo['card-number']"
                                   v-model="baseInfo['card-number']"
                                   :readOnly="isCreditUpdate"

                      />
                    </div>
                    <div class="col-2">
                      <formControl :label="$t('orders.cardHolderYear')"
                                   type="text"
                                   name="cardHolderYear"
                                   class="mb-2"
                                   v-validate="'required'"
                                   :val="baseInfo['cardholder-year']"
                                   v-model="baseInfo['cardholder-year']"
                                   :readOnly="isCreditUpdate"
                      />
                    </div>
                    <div class="col-1">
                      <formControl :label="$t('orders.cardHolderMonth')"
                                   type="text"
                                   name="cardHolderMonth"
                                   class="mb-2"
                                   v-validate="'required'"
                                   :val="baseInfo['cardholder-month']"
                                   v-model="baseInfo['cardholder-month']"
                                   :readOnly="isCreditUpdate"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <ul class="nav nav-tabs nav-justified" v-if=" !baseInfo['replicate']">
        <li class="nav-item"
            v-if="isTable(['orders', 'leads', 'calculator', 'tasks', 'clients']) || routePartOfOrdersGroup()">
          <a class="nav-link" @click.prevent="setActive('notes')" :class="{ active: isActive('notes') }" href="#notes">
            <span v-if="isTable(['orders'])">{{ $t('orders.ongoingTreatment') }}</span>
            <span v-else>{{ $t('orders.notes') }}</span>
          </a>
        </li>
        <li class="nav-item" v-if="isTable(['orders']) || routePartOfOrdersGroup()">
          <a class="nav-link" @click.prevent="setActive('conditions')" :class="{ active: isActive('conditions') }"
             href="#files">{{ $t('orders.policyConditions') }}</a>
        </li>
        <li class="nav-item"
            v-if="isTable(['orders', 'leads', 'calculator', 'tasks', 'clients']) || routePartOfOrdersGroup()">
          <a class="nav-link" @click.prevent="setActive('messages')" :class="{ active: isActive('messages')}"
             href="#messages">{{ $t('orders.messages') }}</a>
        </li>
        <li class="nav-item"
            v-if="isTable(['orders', 'leads', 'calculator', 'tasks', 'clients']) || routePartOfOrdersGroup()">
          <a class="nav-link" @click.prevent="setActive('files')" :class="{ active: isActive('files') }" href="#files">{{
              $t('orders.files')
            }}</a>
        </li>
        <li class="nav-item" v-if="isTable(['orders']) || routePartOfOrdersGroup()">
          <a class="nav-link" @click.prevent="setActive('drafts')" :class="{ active: isActive('drafts') }"
             href="#files">{{ $t('orders.drafts') }}</a>
        </li>
      </ul>

      <div class="tab-content py-3" id="myTabContent" v-if="!baseInfo['replicate']">
        <!--notes-->
        <div class="tab-pane fade" :class="{ 'active show': isActive('notes') }" id="notes">
          <!--NOTES-->
          <div v-if="isTable(['orders']) || routePartOfOrdersGroup()" class="row mb-3">
            <ul class="nav nav-tabs nav-justified w-100">
              <li class="nav-item ">
                <a class="nav-link cursor-pointer item-box"
                   @click="setOngoingTreatment('ongoingTreatment1', 'הערות הזמנה')"
                   :class="{ 'sub-active': activeOngoingTreatmentItem === 'ongoingTreatment1' }">
                  <span class="font-weight-bold">הערות הזמנה</span>
                </a>
              </li>
              <!--              <li class="nav-item">-->
              <!--                <a class="nav-link" @click="setOngoingTreatment('ongoingTreatment2')"-->
              <!--                   :class="{ 'sub-active': activeOngoingTreatmentItem === 'ongoingTreatment2' }">-->
              <!--                  <span>סטטוס הזמנה</span>-->
              <!--                </a>-->
              <!--              </li>-->
              <li class="nav-item">
                <a class="nav-link cursor-pointer item-box"
                   @click="setOngoingTreatment('ongoingTreatment2', 'עבר ביטוחי')"
                   :class="{ 'sub-active': activeOngoingTreatmentItem === 'ongoingTreatment2' }">
                  <span class="font-weight-bold">עבר ביטוחי</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link cursor-pointer item-box" @click="setOngoingTreatment('ongoingTreatment3', 'מיגון')"
                   :class="{ 'sub-active': activeOngoingTreatmentItem === 'ongoingTreatment3' }">
                  <span class="font-weight-bold">מיגון</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link cursor-pointer item-box" @click="setOngoingTreatment('ongoingTreatment4', 'ביטול')"
                   :class="{ 'sub-active': activeOngoingTreatmentItem === 'ongoingTreatment4' }">
                  <span class="font-weight-bold">ביטול</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link cursor-pointer item-box" @click="setOngoingTreatment('ongoingTreatment5', 'שינויים')"
                   :class="{ 'sub-active': activeOngoingTreatmentItem === 'ongoingTreatment5' }">
                  <span class="font-weight-bold">שינויים</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link cursor-pointer item-box" @click="setOngoingTreatment('ongoingTreatment6', 'גביה')"
                   :class="{ 'sub-active': activeOngoingTreatmentItem === 'ongoingTreatment6' }">
                  <span class="font-weight-bold">גביה</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link cursor-pointer item-box" @click="setOngoingTreatment('ongoingTreatment7', 'תביעות')"
                   :class="{ 'sub-active': activeOngoingTreatmentItem === 'ongoingTreatment7' }">
                  <span class="font-weight-bold">תביעות</span>
                </a>
              </li>
            </ul>
          </div>

          <div class="col-12" v-if="isTable([ 'orders']) || routePartOfOrdersGroup()">
            <div class="card border-0 shadow" v-if="ongoingTreatmentObject[activeOngoingTreatmentItem]">
              <div class="card border-0 shadow">
                <div class="card-header d-flex justify-content-between">
                  <h5> {{ $t('orders.notes') }}</h5>
                  <div class="d-flex flex-row">
                    <button class="btn btn-color-1 btn-sm" type="button" data-toggle="collapse"
                            data-target="#collapseExample" aria-expanded="false"
                            aria-controls="collapseExample">{{ $t('orders.addNewNote') }}
                    </button>
                  </div>
                </div>

                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-12">
                      <form @submit.prevent="prepareManualComment" ref="noteForm" class="collapse show mb-2"
                            id="collapseExample"
                            data-vv-scope="note">
                        <formControl type="select"
                                     name="subject"
                                     id="subject"
                                     class="mb-2" disabled="">
                          <option :value="activeOngoingTreatmentLabel">{{ activeOngoingTreatmentLabel }}</option>
                          <!--                          <option :value="$t('orders.general')">{{ $t('orders.general') }}</option>
                                                    <option :value="$t('orders.production')">{{ $t('orders.production') }}
                                                    </option>
                                                    <option :value="$t('orders.payment')">{{ $t('orders.payment') }}</option>-->
                        </formControl>
                        <formControl type="textarea"
                                     name="note"
                                     rows="4"
                                     id="note"
                                     class="mb-2"
                                     v-validate="'required'"
                                     :error="errors.first('note.note')"
                                     :val="editNoteObj.note || ''"

                        />
                        <div class="slider-checkbox mb-2">
                          <input type="checkbox" id="isHighlightNote" name="isHighlightNote" v-model="isChecked"
                                 @click="checkStatus">
                          <label for="isHighlightNote" class="mx-1 mb-0">להדגיש הערה</label>
                        </div>


                        <button type="submit" class="btn btn-color-1">
                          {{ !editNoteObj.note ? $t('orders.save') : $t('orders.update') }}
                        </button>
                      </form>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-sm mb-0">
                      <thead>
                      <tr>
                        <th class="font-weight-normal">{{ $t('orders.subject') }}</th>
                        <th class="font-weight-normal">{{ $t('orders.description') }}</th>
                        <th class="font-weight-normal">{{ $t('orders.by') }}</th>
                        <th class="font-weight-normal">{{ $t('orders.time') }}</th>
                        <th class="font-weight-normal">פעילות</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in notes"
                          v-if="ongoingTreatmentObject[activeOngoingTreatmentItem].includes(item['subject'])"
                          :class="{ 'highlight-row': item.isHighlightNote === 1 }">
                        <td>{{ item['subject'] }}</td>
                        <!--                        <td class="white-space">{{checkForHref(item['description'])}}</td>-->
                        <td class="white-space" v-html="checkForHref(item['description'])"></td>
                        <formControl
                          ref="editNot"
                          refInFor
                          type="textarea"
                          name="note"
                          :id="'note_'+item['id']"
                          :val="item['description']"
                          class="d-none"
                        />
                        <td>{{ item['user'] }}</td>
                        <td>{{ item['created_at'] }}</td>
                        <td>
                          <div v-if="$store.getters.isAdmin || $store.getters.isManagement"
                               class="d-flex justify-content-around">
                            <button class="btn btn-sm btn-color-1 rounded-0 w-75 mx-1"
                                    @click="editNote(item['id'], item['description'])">עדכן
                            </button>
                            <button class="btn btn-sm btn-color-1 rounded-0 w-75 mx-1 bg-danger border-danger">מחק
                            </button>
                          </div>
                          <div v-else>
                            <button v-if="isAllowToEdit(item['created_at'])"
                                    class="btn btn-sm btn-color-1 rounded-0 w-75 mx-1"
                                    @click="editNote(item['id'], item['description'])">עדכן
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div v-if="isTable([ 'leads', 'calculator', 'tasks', 'clients'])" class="row mb-3">
            <div class="col-12">
              <div class="card border-0 shadow">
                <div class="card-header d-flex justify-content-between">
                  <h5> {{ $t('orders.notes') }} </h5>
                  <div class="d-flex flex-row">
                    <button class="btn btn-color-1 btn-sm" type="button" data-toggle="collapse"
                            data-target="#collapseExample" aria-expanded="false"
                            aria-controls="collapseExample">{{ $t('orders.addNewNote') }}
                    </button>
                  </div>
                </div>

                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-12">
                      <form @submit.prevent="prepareManualComment" class="collapse mb-2" id="collapseExample"
                            data-vv-scope="note">
                        <formControl type="select"
                                     name="subject"
                                     id="subject"
                                     class="mb-2">
                          <option :value="$t('orders.general')">{{ $t('orders.general') }}</option>
                          <option :value="$t('orders.production')">{{ $t('orders.production') }}
                          </option>
                          <option :value="$t('orders.payment')">{{ $t('orders.payment') }}</option>
                        </formControl>
                        <formControl type="textarea"
                                     name="note"
                                     rows="4"
                                     id="note"
                                     class="mb-2"
                                     v-validate="'required'"
                                     :error="errors.first('note.note')"

                        />
                        <button type="submit" class="btn btn-color-1">{{ $t('orders.save') }}</button>
                      </form>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-sm mb-0">
                      <thead>
                      <tr>
                        <th class="font-weight-normal">{{ $t('orders.subject') }}</th>
                        <th class="font-weight-normal">{{ $t('orders.description') }}</th>
                        <th class="font-weight-normal">{{ $t('orders.by') }}</th>
                        <th class="font-weight-normal">{{ $t('orders.time') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in notes">
                        <td>{{ item['subject'] }}</td>
                        <td class="white-space">{{ item['description'] }}</td>
                        <td>{{ item['user'] }}</td>
                        <td>{{ item['created_at'] }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tab-pane fade" :class="{ 'active show': isActive('conditions') }" id="conditions">
          <!--CONDITIONS-->
          <div v-if="(isTable(['orders']) || routePartOfOrdersGroup()) && baseInfo['add-info']" class="row mb-3">
            <div class="col-12">
              <div class="card border-0 shadow">

                <div class="card-header d-flex justify-content-between">
                  <h5> {{ $t('orders.policyConditions') }} </h5>
                  <button class="bg-color-2 p-2 position-relative rounded-circle align-self-center border-0"
                          data-toggle="collapse" data-target="#collapseConditions" aria-expanded="false"
                          aria-controls="collapseExample">
                    <i class="fa fa-chevron-down text-white xy-align"></i>
                  </button>
                </div>
                <div class="collapse show" id="collapseConditions">

                  <div class="card-body">
                    <div v-if="baseInfo['extensionMoreDetails']" >
                        <div v-for="extension in extensionMoreDetails">
                          <div style="height: 30px; padding-right: 5px; border-bottom: 1px solid #d5d5d5; font-size: 13px">
                            <span style="font-weight: 500">{{extension.name}}</span>
                            <span>{{extension.content}}</span>
                          </div>

                        </div>
                    </div>
                    <div class="table-responsive add-info" v-html="baseInfo['add-info']">

                      <!--<table class="table table-sm mb-0">
                          <thead>
                          <tr>
                              <th class="font-weight-normal">{{$t('orders.status')}}</th>
                              <th class="font-weight-normal">{{$t('orders.type')}}</th>
                              <th class="font-weight-normal">{{$t('orders.period')}}</th>
                              <th class="font-weight-normal">{{$t('orders.insNum')}}</th>
                              <th class="font-weight-normal">{{$t('orders.source')}}</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                              <td>
                                  {{baseInfo['status']}}
                              </td>
                              <td>{{baseInfo['ins-type']}}</td>
                              <td>{{baseInfo['insurance-date-start']}} {{$t('orders.to')}}
                                  {{baseInfo['insurance-date-finish']}}
                              </td>
                              <td>{{baseInfo['ins_order']}}</td>
                              <td>{{baseInfo['source']}}</td>
                          </tr>
                          </tbody>
                      </table>-->
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" :class="{ 'active show': isActive('messages') }" id="messages">
          <!--MESSAGES-->
          <div v-if="isTable(['orders', 'leads', 'calculator', 'tasks', 'clients']) || routePartOfOrdersGroup()"
               class="row mb-3">
            <div class="col-12">
              <div class="card border-0 shadow">
<!--                <div class="row">
                  <div class="col-12 d-flex justify-content-center mt-2">
                    <button type="button" class="btn btn-color-1 mr-2"
                            :class="{ 'bg-success': selectedMessageType === 'emails' }"
                            @click="changeMessageType('emails')">אימייל
                    </button>
                    <button type="button" class="btn btn-color-1 mr-2"
                            :class="{ 'bg-success': selectedMessageType === 'sms' }" @click="changeMessageType('sms')">
                      SMS
                    </button>
                    <button type="button" class="btn btn-color-1 mr-2"
                            :class="{ 'bg-success': selectedMessageType === 'whatsapp' }"
                            @click="changeMessageType('whatsapp')">ווטסאפ
                    </button>
                  </div>
                </div>-->

                <div class="card-header d-flex justify-content-between">
                  <h5> {{ $t('orders.messages') }} </h5>
                  <div class="d-flex flex-row">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button class="btn btn-color-3" type="button"
                                data-toggle="collapse"
                                data-target="#msg">
                          {{ $t('orders.newMsg') }}
                        </button>
                      </div>
                      <label for="msgType" class="sr-only">{{ $t('orders.newMsg') }}</label>
                        <select class="form-control" id="msgType" ref="msgType" @change="requestMsg()">
                         <option value="">רשימת הודעות </option>
                          <option value="0000">הודעה חופשית</option>
                        <option v-for="msg in messages" v-if="msg.isShowMessage"
                                :value="msg.id">
                          {{ msg.displayName }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <template v-if="!dataTableReady && msg.messageId !== '' && (msg.isEmail || msg.isSms || msg.isWhatsapp)">
                      <form @submit.prevent="sendMsg" class="collapse mb-2 show" id="msg">
                        <formControl
                          type="hidden"
                          name="messageId"
                          id="messageId"
                          :val="$route.query.id"
                          v-model="msg.messageId">
                        </formControl>
                        <div class="row">

                          <!-- Messages - Email Display  -->
                          <div class="col-lg-4" :key="`email_${msg.isEmail}`">
                            <div class="w-100">
                              <div class="d-flex align-items-center justify-content-center mb-3">
                                <input
                                  type="checkbox"
                                  :id="`isEmail_${_uid}`"
                                  :checked="msg.isEmail"
                                  @change="toggleMessageChannel('email')"
                                  class="mx-1"

                                />
                                <p class="text-center font-weight-bold text-color-3 h3 mb-0">אימייל</p>
                              </div>
                              <div v-if="msg.isEmail">
                                <div class="row" v-if="msg.isEmail">
                                  <div class="col-6">

                                    <div class="form-group position-relative w-100" value="">
                                      <label for="msgSubject" class="mb-0">נושא</label>
                                      <input type="text" id="msgSubject" name="subject"   :val="msg.subject"   v-model="msg.subject" :readOnly="msg.isEditable" class="form-control w-100">
                                    </div>
                                  </div>

                                </div>
                                <div class="row">
                                  <div class="col-12" >

                                    <!--<small>{{$t('orders.addressNotSelected')}}</small>-->
                                    <multiselect
                                      id="address"
                                      v-model="msg.phoneBookAddress"
                                      :options="options.phoneBook"
                                      label="fullName"
                                      track-by="fullName"
                                      :multiple="true"
                                      :placeholder="$t('orders.selectContact')"
                                      :selectLabel="$t('orders.select')"
                                      :deselectLabel="$t('orders.remove')"
                                    />
                                  </div>
                                </div>
                                <formControl label=""
                                             type="textarea"
                                             name="body"
                                             rows="20"
                                             id="body"
                                             class="mb-2 w-100"
                                             :val="msg.content"
                                             v-model="msg.content"
                                             :readOnly="msg.isEditable"
                                />

                                <div v-if="files" class="form-group">
                                  <label class="mb-0">{{ $t('orders.msgFiles') }}</label>
                                  <multiselect
                                    v-model="msg.files"
                                    :options="files"
                                    label="name"
                                    track-by="id"
                                    :multiple="true"
                                    class="mb-2"
                                    :placeholder="$t('orders.selectFiles')"
                                    :selectLabel="$t('orders.select')"
                                    :deselectLabel="$t('orders.remove')"
                                    v-validate="msg.isEditFile ? 'required' : ''"
                                    :error="errors.first('note.note')"
                                  />
                                </div>
                                <formControl :label="$t('tables.headers.replayTo')"
                                             type="email"
                                             name="replayTo"
                                             rows="4"
                                             id="replayTo"
                                             class="mb-2"
                                             :val="msg.replayTo"
                                             v-model="msg.replayTo"
                                />
                              </div>
                            </div>
                          </div>
                          <!-- Messages - SMS Display  -->
                          <div class="col-lg-4" :key="`sms_${msg.isSms}`">
                            <div class="w-100">
                              <div class="d-flex align-items-center justify-content-center mb-3">
                                <input
                                  type="checkbox"
                                  :id="`isSms_${_uid}`"
                                  :checked="msg.isSms"
                                  @change="toggleMessageChannel('sms')"
                                  class="mx-1"

                                />
                                <p class="text-center font-weight-bold text-color-3 h3 mb-0">SMS</p>
                              </div>
                              <div v-if="msg.isSms">
                              <formControl
                                :label="'מספר נייד'"
                                type="tel"
                                name="smsPhoneNumber"
                                id="msgSmsPhoneNumber"
                                class=""
                                :val="msg.smsPhoneNumber"
                                v-model="msg.smsPhoneNumber"
                                :readOnly="msg.isEditable">
                              </formControl>

                              <formControl   label=""
                                           type="textarea"
                                           name="body"
                                           rows="20"
                                           id="smsBody"
                                           class="mb-2 "
                                           :val="msg.smsContent"
                                           v-model="msg.smsContent"
                                           :readOnly="msg.isEditable"
                                           :maxlength="'130'"

                              />
                              </div>

                            </div>
                          </div>
                          <!-- Messages - Whatsapp Display  -->
                          <div class="col-lg-4" :key="`whatsapp_${msg.isWhatsapp}`">
                            <div class="w-100">
                              <div class="d-flex align-items-center justify-content-center mb-3">
                                <input
                                  type="checkbox"
                                  :id="`isWhatsapp_${_uid}`"
                                  :checked="msg.isWhatsapp"
                                  @change="toggleMessageChannel('whatsapp')"
                                  class="mx-1"

                                />
                                <p class="text-center font-weight-bold text-color-3 h3 mb-0">וואטסאפ</p>
                              </div>
                              <div v-if="msg.isWhatsapp  ">
                              <formControl
                                :label="'מספר נייד'"
                                type="tel"
                                name="smsPhoneNumber"
                                id="msgSmsPhoneNumber"
                                class=""
                                :val="msg.smsPhoneNumber"
                                v-model="msg.smsPhoneNumber"
                                :readOnly="msg.isEditable">
                              </formControl>

                              <formControl   label=""
                                           type="textarea"
                                           name="body"
                                           rows="20"
                                           id="smsBody"
                                           class="mb-2 "
                                           :val="msg.whatsappContent"
                                           v-model="msg.whatsappContent"
                                           :readOnly="true"
                                           :maxlength="'130'"

                              />
                              </div>

                            </div>
                          </div>
                        </div>
                        <button type="submit" class="btn btn-color-1" :disabled='isButtonClicked'>
                          {{ $t('orders.submit') }}
                        </button>

                      </form>
                    </template>

                  </div>

                </div>
                <div class="card-body">
                  <div class="row ">
                    <div class="col-lg-12">
<!--                      <template v-if="!dataTableReady">
                        <form @submit.prevent="sendMsg" class="collapse mb-2 show" id="msg">
                          <formControl
                            type="hidden"
                            name="messageId"
                            id="messageId"
                            :val="$route.query.id"
                            v-model="msg.messageId">
                          </formControl>

                          <div class="row">
                            <div class="col-lg-4" v-if="msg.autoSend === 0 && msg.isWhatsapp === 0">
                              <label for="address" class="mb-0">{{ $t('orders.address') }}</label>
                              &lt;!&ndash;<small>{{$t('orders.addressNotSelected')}}</small>&ndash;&gt;
                              <multiselect
                                id="address"
                                v-model="msg.phoneBookAddress"
                                :options="options.phoneBook"
                                label="fullName"
                                track-by="fullName"
                                :multiple="true"
                                :placeholder="$t('orders.selectContact')"
                                :selectLabel="$t('orders.select')"
                                :deselectLabel="$t('orders.remove')"
                              />
                            </div>
                            <formControl v-if="msg.autoSend === 0 && msg.isWhatsapp === 0 "
                                         :label="$t('orders.secondMailAddress')"
                                         type="text"
                                         name="secondMailAddress"
                                         id="secondMailAddress"
                                         class="col-lg-4"
                                         :val="msg.secondMailAddress"
                                         v-model="msg.secondMailAddress">
                            </formControl>
                            <formControl v-if="msg.autoSend !== 3 && msg.isWhatsapp === 0 "
                                         :label="$t('orders.subject')"
                                         type="text"
                                         name="subject"
                                         id="msgSubject"
                                         class="col-lg-4"
                                         :val="msg.subject"
                                         v-model="msg.subject"
                                         :readOnly="msg.isEditable">
                            </formControl>
                            <formControl v-if="msg.autoSend === 3 && msg.isWhatsapp === 0 "
                                         :label="$t('tables.headers.smsPhoneNumber')"
                                         type="tel"
                                         name="smsPhoneNumber"
                                         id="msgSmsPhoneNumber"
                                         class="col-lg-4"
                                         :val="msg.smsPhoneNumber"
                                         v-model="msg.smsPhoneNumber"
                                         :readOnly="msg.isEditable">
                            </formControl>
                          </div>

                          <formControl v-if="msg.autoSend !== 3 && msg.isWhatsapp !== 1 " :label="$t('orders.body')"
                                       type="textarea"
                                       name="body"
                                       rows="20"
                                       id="body"
                                       class="mb-2"
                                       :val="msg.content"
                                       v-model="msg.content"
                                       :readOnly="msg.isEditable"
                          />
                          &lt;!&ndash;                          <div  class="visual-preview"&ndash;&gt;
                          &lt;!&ndash;                               v-html="msg.content"&ndash;&gt;
                          &lt;!&ndash;                               style="border: 1px solid #ccc; padding: 10px;" />&ndash;&gt;

                          <formControl v-if="msg.autoSend === 3 || msg.isWhatsapp === 1 " label="גוף הודעת טקסט"
                                       type="textarea"
                                       name="body"
                                       rows="20"
                                       id="smsBody"
                                       class="mb-2"
                                       :val="msg.smsContent"
                                       v-model="msg.smsContent"
                                       :readOnly="msg.isEditable"
                                       :maxlength="'130'"

                          />
                          &lt;!&ndash;:readOnly="item.name === 'smsContent' && mainForm[item.name].length === 130"&ndash;&gt;


                          <div v-if="files" class="form-group">
                            <label class="mb-0">{{ $t('orders.msgFiles') }}</label>
                            <multiselect
                              v-model="msg.files"
                              :options="files"
                              label="name"
                              track-by="id"
                              :multiple="true"
                              class="mb-2"
                              :placeholder="$t('orders.selectFiles')"
                              :selectLabel="$t('orders.select')"
                              :deselectLabel="$t('orders.remove')"
                              v-validate="msg.isEditFile ? 'required' : ''"
                              :error="errors.first('note.note')"
                            />
                          </div>
                          <formControl :label="$t('tables.headers.replayTo')"
                                       type="email"
                                       name="replayTo"
                                       rows="4"
                                       id="replayTo"
                                       class="mb-2"
                                       :val="msg.replayTo"
                                       v-model="msg.replayTo"
                          />

                          <button type="submit" class="btn btn-color-1" :disabled='isButtonClicked'>
                            {{ $t('orders.submit') }}
                          </button>
                        </form>
                      </template>
                      <template v-else>
                        <loader/>
                      </template>-->
                    </div>
                  </div>

                  <!-- Messages List Show-->
                  <div class="table-responsive">
                    <table class="table table-sm mb-0">
                      <thead>
                      <tr>
                        <th class="font-weight-normal">{{ $t('orders.address') }}</th>
                        <th class="font-weight-normal">{{ $t('orders.subject') }}</th>
                        <th class="font-weight-normal">{{ $t('orders.content') }}</th>
                        <th class="font-weight-normal">{{ $t('orders.smsContent') }}</th>
                        <th class="font-weight-normal">{{ $t('tables.headers.smsPhoneNumber') }}</th>
                        <th class="font-weight-normal">{{ $t('orders.autoSend') }}</th>
                        <th class="font-weight-normal">{{ $t('orders.time') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="mail in mails">
                        <td>{{ mail['address'] }}</td>
                        <td>{{ mail['subject'] }}</td>
                        <td><textarea class="w-100 border-0 overflow-hidden">{{mail['content']}}</textarea></td>
                        <td><textarea class="w-100 border-0 overflow-hidden">{{mail['smsContent']}}</textarea></td>
                        <td>{{ mail['smsPhoneNumber'] }}</td>
                        <td>{{ mail['autoSend'] ? $t('orders.yes') : $t('orders.no') }}</td>
                        <td>{{ mail['created_at'] }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" :class="{ 'active show': isActive('files') }" id="files">
          <!--FILES-->
          <div v-if="isTable(['orders', 'leads', 'calculator', 'tasks']) || routePartOfOrdersGroup()" class="row mb-3">
            <div class="col-12">
              <div class="card border-0 shadow">
                <h5 class="card-header">{{ $t('orders.files') }}</h5>
                <div class="card-body">

                  <div class="row mb-2">
                    <div class="col-12">
                      <vue2-dropzone
                        ref="myVueDropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        class="w-100 border-color-1"
                        style="border: 1px dashed; min-height: auto; padding: 0 0;"
                        :useCustomSlot=true
                        @vdropzone-success="appendData()"
                      >
                        <div class="text-color-1 d-flex flex-row align-self-center justify-content-center">
                          <span class="icon-download h1 mb-0"></span>
                          <span class="h2 mb-0 mr-2">{{ $t('orders.dragFiles') }}</span>
                        </div>
                      </vue2-dropzone>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-sm mb-0">
                      <thead>
                      <tr>
                        <th class="font-weight-normal">{{ $t('orders.fileName') }}</th>
                        <th class="font-weight-normal">{{ $t('orders.title') }}
                          <small>{{ $t('orders.clickToEdit') }}</small>
                        </th>
                        <th class="font-weight-normal">עודכן ב</th>
                        <th class="font-weight-normal">עודכן ע"י</th>
                        <th class="font-weight-normal">{{ $t('orders.actions') }}</th>
                        <th class="font-weight-normal">תצוגת קובץ</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in files" ref="fileRow">
                        <td><span>{{ item['name'] }}</span></td>
                        <td>
                              <span contenteditable="true"
                                    @input="allowFileUpdate($event ,item['id'])"
                                    :ref="`file_${item['id']}_title`">
                                  {{ item['title'] ? item['title'] : item['name'] }}
                              </span>
                        </td>
                        <!--<td>
                                <span contenteditable="true"
                                      @input="allowFileUpdate($event ,item['id'])"
                                      :ref="`file_${item['id']}_description`">
                                    {{item['description'] ? item['description'] : $t('orders.noDescription')}}
                                </span>
                        </td>-->
                        <td>
                          <span>{{ item['created_at'] }}</span>
                        </td>
                        <td>
                          <span>{{ item['userName'] }}</span>
                        </td>
                        <td>
                          <button class="btn btn-color-1 btn-sm px-1" type="button"
                                  :ref="`file_${item['id']}_update`"
                                  @click="editFile(item['id'], 'update')">
                            עדכן
                          </button>

                          <button v-if="$store.getters.isAdmin" class="btn btn-danger btn-sm px-1 mx-1" type="button"
                                  :ref="`file_${item['id']}_remove`"
                                  @click="editFile(item['id'], 'remove')">
                            מחק
                          </button>

                          <!--<button class="btn btn-link px-1"
                                  @click="editFile(item['id'], 'remove')"><span
                            class="icon icon-trash icon-xs"></span></button>-->


                          <span class="icon icon-download icon-xs px-1" @click="downloadPic"></span>


                          <a v-if="item['url']" :href="item['url']" target="_blank" download
                             class="btn btn-link px-1">
                            <span class="icon icon-eye icon-xs"></span>
                          </a>

                        </td>
                        <td>
                          <div v-if="checkFileType(item['url']) " @click="openPdfInNewTab(item['url'])"
                               style="cursor: pointer;">
                            <embed
                              :src="item['url']"
                              type="application/pdf"
                              width="150px"
                              height="150px"
                              style="pointer-events: none;">
                          </div>
                          <div v-else>
                            <a :href="item['url']" target="_blank">
                              <img :src="item['url']" width="150" height="150"/>
                            </a>
                          </div>

                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" :class="{ 'active show': isActive('drafts') }" id="drafts">
          <!--DRAFTS-->
          <div v-if="isTable(['orders']) || routePartOfOrdersGroup()" class="row mb-3">
            <div class="col-12">
              <div class="card border-0 shadow">

                <div class="card-header d-flex justify-content-between">
                  <h5> {{ $t('orders.drafts') }} </h5>
                  <button class="bg-color-2 p-2 position-relative rounded-circle align-self-center border-0"
                          data-toggle="collapse" data-target="#collapseDrafts" aria-expanded="false"
                          aria-controls="collapseExample">
                    <i class="fa fa-chevron-down text-white xy-align"></i>
                  </button>
                </div>
                <div class="collapse" id="collapseDrafts">

                  <div class="card-body">

                    <div class="table-responsive">
                      <table class="table table-sm mb-0 vue-datatables">
                        <thead>
                        <tr>
                          <th></th>
                          <th v-for="(item, i) in drafts[0]" class="font-weight-normal"
                              style="min-width: 200px">
                            <small>{{ $t('tables.headers.' + i) }}</small>
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, i) in drafts">
                          <td>
                            <span class="icon icon-eye icon-xs cursor-pointer"
                                  @click="e => openDraft(e, item.id)"></span>
                          </td>
                          <td v-for="value in item" class="td-wrapper">
                            <small>{{ value }}</small>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Clients Orders-->
      <div v-if="isTable(['clients']) && customer.orders.length" class="row mb-3">
        <div class="col-12">
          <div class="card border-0 shadow">

            <div class="card-header d-flex justify-content-between">
              <h5> {{ $t('sidenav.orders') }} </h5>
              <button class="bg-color-2 p-2 position-relative rounded-circle align-self-center border-0"
                      data-toggle="collapse" data-target="#collapseClientsOrder" aria-expanded="false"
                      aria-controls="collapseExample">
                <i class="fa fa-chevron-down text-white xy-align"></i>
              </button>
            </div>
            <div class="collapse" id="collapseClientsOrder">

              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-sm mb-0 vue-datatables">
                    <thead>
                    <tr>
                      <th></th>
                      <th v-for="(item, i) in customer.orders[0]" class="font-weight-normal"
                          style="min-width: 200px">
                        <small>{{ $t('tables.headers.' + i) }}</small>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, i) in customer.orders">
                      <td>
                        <span class="icon icon-eye icon-xs cursor-pointer"
                              @click="e => openUrl(e, item.id, 'orders')"></span>
                      </td>
                      <td v-for="value in item" class="td-wrapper">
                        <small>{{ value }}</small>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Clients Leads-->
      <div v-if="isTable(['clients']) && customer.leads.length" class="row mb-3">
        <div class="col-12">
          <div class="card border-0 shadow">

            <div class="card-header d-flex justify-content-between">
              <h5> {{ $t('sidenav.leads') }} </h5>
              <button class="bg-color-2 p-2 position-relative rounded-circle align-self-center border-0"
                      data-toggle="collapse" data-target="#collapseClientsLeads" aria-expanded="false"
                      aria-controls="collapseExample">
                <i class="fa fa-chevron-down text-white xy-align"></i>
              </button>
            </div>
            <div class="collapse" id="collapseClientsLeads">

              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-sm mb-0 vue-datatables">
                    <thead>
                    <tr>
                      <th></th>
                      <th v-for="(item, i) in customer.leads[0]" class="font-weight-normal"
                          style="min-width: 200px">
                        <small>{{ $t('tables.headers.' + i) }}</small>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, i) in customer.leads">
                      <td>
                        <span class="icon icon-eye icon-xs cursor-pointer"
                              @click="e => openUrl(e, item.id, 'leads')"></span>
                      </td>
                      <td v-for="value in item" class="td-wrapper">
                        <small>{{ value }}</small>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Clients Tasks-->
      <div v-if="isTable(['clients']) && customer.tasks.length" class="row mb-3">
        <div class="col-12">
          <div class="card border-0 shadow">

            <div class="card-header d-flex justify-content-between">
              <h5> {{ $t('sidenav.tasks') }} </h5>
              <button class="bg-color-2 p-2 position-relative rounded-circle align-self-center border-0"
                      data-toggle="collapse" data-target="#collapseClientsTasks" aria-expanded="false"
                      aria-controls="collapseExample">
                <i class="fa fa-chevron-down text-white xy-align"></i>
              </button>
            </div>
            <div class="collapse" id="collapseClientsTasks">

              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-sm mb-0 vue-datatables">
                    <thead>
                    <tr>
                      <th></th>
                      <th v-for="(item, i) in customer.tasks[0]" class="font-weight-normal"
                          style="min-width: 200px">
                        <small>{{ $t('tables.headers.' + i) }}</small>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, i) in customer.tasks">
                      <td>
                        <span class="icon icon-eye icon-xs cursor-pointer"
                              @click="e => openUrl(e, item.id, 'tasks')"></span>
                      </td>
                      <td v-for="value in item" class="td-wrapper">
                        <small>{{ value }}</small>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade " ref="orderReplicatesModal" id="orderReplicatesModal">
        <div class="modal-dialog">
          <div class="modal-content" style="width: 1200px">

            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title w-100">גרסאות קודמות</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">
              <div v-for="(row, i) in replicates">
                <a href="" @click="e => openDraft(e, row.id)">
                  <div class="mx-1 mb-2 line-height-1">
                    <span>הזמנה {{ row.id }}</span> |
                    <span>עודכנה ב: {{ row.created_at }}</span> |
                    <span>ע"י: {{ row.updatedByUserName }}</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade " ref="productHistoryModal" id="productHistoryModal" v-if="products">
        <div class="modal-dialog">
          <div class="modal-content" style="width: 1200px">

            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title w-100">ההיסטוריה של המוצר</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">
              <table class="table table-sm mb-0">
                <thead>
                <tr>
                  <th class="font-weight-normal" v-for="(product, i) in products[0]"
                      v-if="i !== 'updated_at' && i !== 'created_at' && i !== 'id' && i !== 'productFile' && i !== 'orderId' && i !== 'costPerMount'">
                    {{ $t('tables.headers.' + i) }}
                  </th>
                  <th>
                    <td>עודכן ב</td>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="productsHistory" v-for="(product, k) in productsHistory" :key="k">
                  <td v-for="(item, i) in config.productsSchema" :key="i"
                      v-if=" item.name !== 'updated_at'  && item.name !== 'id' && item.name !== 'orderId'">
                    <div class="td-wrapper" :ref="k+'_'+item.name" v-if="product.productId === productsHistoryShowId">
                      <div v-if="item.name === 'statusId'">
                          <span v-if="product[item.name] === 2"
                                class="text-danger"> {{ translate(product[item.name], item.name) }}</span>
                        <span v-if="product[item.name] === 1"
                              class="text-black"> {{ translate(product[item.name], item.name) }}</span>
                      </div>
                      <span v-if="item.name !== 'statusId'">{{ translate(product[item.name], item.name) }}</span>

                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="shouldBlockInteraction"
        id="overlay-blocker"
      ></div>

      <!-- Draft Order Modal -->
      <draftOrderModel ref="draftOrderModel" :baseInfo="baseInfo"/>

    </template>
    <template v-else>
      <loader/>
    </template>
  </div>
</template>
<script>

import axios from '../axios'
import formControl from '@/components/formcontrol'
import vue2Dropzone from 'vue2-dropzone'
import Multiselect from 'vue-multiselect'
import breadCrumbs from '@/components/breadcrumbs'
import loader from '@/components/loader'
import draftOrderModel from '@/views/Modal/draftOrderModel'
import messageForm from '@/templates/add-new-message.vue'
import baseUrl from '../config'
import store from "../store";
import {checkWhatsappUser, splitName} from '@/utils/utilsFunctions.js';
import alert from "@/components/alert.vue";
import {fa} from "vuejs-datepicker/dist/locale";

export default {
  components: {breadCrumbs, formControl, vue2Dropzone, Multiselect, loader, draftOrderModel, messageForm},
  created() {
    let ordersPages = ['orders', 'ordersControl', 'ordersProtect', 'ordersCancellations', 'ordersCollection', 'ordersTasks', 'ordersClaims'];
    // We make manipulations for the new orders routes
    if (ordersPages.includes(this.$route.query.table)) {
      this.$route.query.table = 'orders';
    }
    // we hide the aside bar
    this.id = this.$route.query.id || '';
    if (this.routePartOfOrdersGroup()) {
      $('.aside-table').addClass('d-none')
    }
  },
  async mounted() {
    this.appendData()
    this.updateLogo()
  },
  computed: {
    store() {
      return store
    },

    isRenewalsSource() {
      return this.$route.query.source === 'renewals';
    },

    statusColor() {
      for (let i in this.options.statuses) {
        if (this.statusColorIndex == this.options.statuses[i].key) {
          return this.options.statuses[i].color
        }
      }
    },

    lackOfClaimsColor() {
      for (let i in this.options.lackOfClaims) {
        if (this.lackOfClaimsColorIndex == this.options.lackOfClaims[i].key) {
          return this.options.lackOfClaims[i].color
        }
      }
    },

    paymentStatusColor() {
      for (let i in this.options.paymentStatus) {
        if (this.paymentStatusColorIndex == this.options.paymentStatus[i].key) {
          return this.options.paymentStatus[i].color
        }
      }
    },

    changesStatusColor() {
      for (let i in this.options.changesStatus) {
        if (this.changesStatusColorIndex == this.options.changesStatus[i].key) {
          return this.options.changesStatus[i].color
        }
      }
    },

    claimsStatusColor() {
      for (let i in this.options.claimsStatus) {
        if (this.claimsStatusColorIndex == this.options.claimsStatus[i].key) {
          return this.options.claimsStatus[i].color
        }
      }
    },

    policyStatusColor() {
      for (let i in this.options.policyStatus) {
        if (this.policyStatusColorIndex == this.options.policyStatus[i].key) {
          return this.options.policyStatus[i].color
        }
      }
    },


    protectionStatus() {
      for (let i in this.options.protectionStatus) {
        if (this.protectionStatusColorIndex == this.options.protectionStatus[i].key) {
          return this.options.protectionStatus[i].color
        }
      }
    },

    renewalStatusColor() {
      for (let i in this.options.renewalsStatus) {
        if (this.renewalStatusColorIndex == this.options.renewalsStatus[i].key) {
          return this.options.paymentStatus[i].color
        }
      }
    },

    uniqueProducts() {
      const products = this.allProductsList.map(p => p.productName);
      return [...new Set(products)];
    },
    uniqueCompanies() {
      const companies = this.allProductsList.map(p => p.companyName);
      return [...new Set(companies)];
    },
    filteredCompanies() {
      if (!this.selectedProduct) {
        return [];
      }

      const companies = this.allProductsList
        .filter(product => product.productName === this.selectedProduct)
        .map(product => product.companyName);

      return [...new Set(companies)];
    },
    productSelectedRow() {
      return this.allProductsList.find(
        item =>
          item.productName === this.selectedProduct &&
          item.companyName === this.selectedCompany &&
          item.description === this.selectedDescription
      );
    },
    filteredDescriptions() {
      if (!this.selectedProduct || !this.selectedCompany) {
        return [];
      }

      const descriptions = this.allProductsList
        .filter(product =>
          product.productName === this.selectedProduct &&
          product.companyName === this.selectedCompany
        )
        .map(product => product.description);

      return [...new Set(descriptions)];
    },
  },

  data: function () {
    return {
      baseInfo: '',
      shouldBlockInteraction: false,
      config: '',
      dataTableReady: false,
      dataReady: false,
      isStatusChanged: false,
      smsMaxLength: 10,
      mainForm: [],
      inRowEdit: '',
      activeItem: 'notes',
      activeOngoingTreatmentItem: 'ongoingTreatment1',
      activeOngoingTreatmentLabel: 'הערות הזמנה',
      activeNotesItem: 1,
      isButtonClicked: false,
      currentStatus: [],
      currentStatusLackOfClaims: [],
      currentStatusPayment: [],
      currentStatusPolicy: [],
      currentStatusChange: [],
      currentStatusClaims: [],
      currentProtectiveStatus: [],
      tokenErrorMsg: false,
      creditShowVal: '',
      newCreditIframeUrl: '',
      isPopupOpen: false,
      popupData: "",
      orders: {
        main,
        car,
        carMakif,
        driverLaw,
        driverHistory,
        driver,
        driver_1,
        driver_2,
        driver_3,
        creditCard,
        carNew,
        driverLawNew,
        driverHistoryNew
      },

      statusColorIndex: '',
      roadServicesIndex: '',
      lackOfClaimsColorIndex: '',
      paymentStatusIndex: '',
      policyStatusIndex: '',
      changesStatusIndex: '',
      claimsStatusIndex: '',
      protectionStatusColorIndex: '',
      renewalStatusColorIndex: '',

      products: '',
      more_orders: '',
      options: '',
      originalStatuses: [],
      productsNames: [
        {key: '1', value: 'חובה'},
        {key: '2', value: 'מקיף'},
        {key: '3', value: 'צד ג'},
        {key: '4', value: '(340)חבילה בסיסית'},
        {key: '5', value: '(450)חבילה משודרגת'},
        {key: '6', value: '(130)פנסים ומראות'},
        {key: '7', value: '(240)רכב חלופי 30'},
        {key: '8', value: '(290)רכב חלופי 60'},
        {key: '9', value: '(85)החלפת ותיקון גלגל'},
        {key: '10', value: '(280)גרירה בלבד'},
        {key: '11', value: '(340)גרירה בלבד רכב ישן גיל 25+'},
        {key: '12', value: '(180)שמשות בלבד'},
        {key: '13', value: 'פיצוי הולם'},
        {key: '14', value: 'כתב שירות'},
        {key: '15', value: 'כתב שירות 1'},
        {key: '16', value: 'כתב שירות 2'},
        {key: '17', value: 'אחר'},
      ],

      companiesNames: [
        {key: '1', value: 'איילון'},
        {key: '2', value: 'איילון דרייבינג'},
        {key: '3', value: 'איילון אוטודיל'},
        {key: '4', value: 'הכשרה'},
        {key: '5', value: 'הכשרה GO'},
        {key: '6', value: 'הכשרה צד ג אקספרס'},
        {key: '7', value: 'הפניקס'},
        {key: '8', value: 'הפניקס זהיר'},
        {key: '9', value: 'הראל'},
        {key: '10', value: 'הראל אפגרייד'},
        {key: '11', value: 'הראל זהב'},
        {key: '12', value: 'הראל סוויצ\''},
        {key: '13', value: 'כלל'},
        {key: '14', value: 'כלל ירוק'},
        {key: '15', value: 'כלל ירוק מוסכים'},
        {key: '16', value: 'כלל מטרז\''},
        {key: '17', value: 'מגדל'},
        {key: '18', value: 'מגדל על'},
        {key: '19', value: 'מנורה G-TOP'},
        {key: '20', value: 'מנורה אוטוטופ'},
        {key: '21', value: 'מנורה טופליין'},
        {key: '22', value: 'שומרה'},
        {key: '23', value: 'שומרה G'},
        {key: '24', value: 'שומרה C'},
        {key: '25', value: 'שומרה C-SHARP'},
        {key: '26', value: 'שומרה טריפל'},
        {key: '27', value: 'שירביט'},
        {key: '28', value: 'שירביט בסט'},
        {key: '29', value: 'שלמה'},
        {key: '30', value: 'שלמה מיני פיקס (325)'},
        {key: '31', value: 'שלמה ללא עבר ביטוחי (328)'},
        {key: '32', value: 'שלמה 2 תביעות (327)'},
        {key: '33', value: 'סטארט'},
        {key: '34', value: 'דרכים'},
      ],
      productsStatuses: [
        {key: '1', value: 'חדש'},
        {key: '2', value: 'בוטל'},
      ],

      notes: '',
      extensionMoreDetails: [],
      externalLinks: '',
      roadServicesList: '',
      productsHistory: '',
      productsHistoryShowId: '',
      files: '',
      drafts: '',
      replicates: '',
      customerOrders: '',
      mails: '',
      messages: '',
      isCustomerExists: '',
      selectedMessageType: 'emails',
      isChecked: false,
      msg: {
        msgType: '',
        messageId: '',
        address: '',
        phoneBookAddress: '',
        subject: '',
        content: '',
        files: [],
        isEditable: '',
        isEditFile: false,
        secondMailAddress: '',
        smsContent: '',
        smsPhoneNumber: '',
        whatsappContent: '',
        whatsappTemplateName: ''
      },
      getDefaultMsg() {
        return {
          msgType: '',
          messageId: '',
          address: '',
          phoneBookAddress: '',
          subject: '',
          content: '',
          files: [],
          isEditable: '',
          isEditFile: false,
          secondMailAddress: '',
          smsContent: '',
          smsPhoneNumber: '',
          whatsappContent: '',
          whatsappTemplateName: ''
        };
      },
      product: {
        companyName: '',
        numberOfPayment: '',
        price: '',
        productName: '',
        startDate: '',
        endDate: '',
        //productFile: '',
        note: '',
        policyNumber: '',
        status: 'חדש',
        selectedInstallment: '',
        deductible: '',
        debtSettlement: '',
        zadGimelRes: '',
        description: '',

      },

      fileUpdateId: '',
      saveButton: false,

      dropzoneOptions: {
        //url: `http://api.hova.co.il/api/${this.$route.query.table}/fileUpload/${this.$route.query.id}`,
        url: `${baseUrl.data()}${this.$route.query.table}/fileUpload/${this.$route.query.id}`,
        thumbnailWidth: 150,
        maxFilesize: 10,
        headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`},
      },
      isCreditUpdate: true,


      orderSchame: [
        {
          name: 'billingDate',
          type: 'text',
          editable: true,
        },
        {
          name: 'license-number',
          type: 'text',
          editable: true,
        },
        {
          validation: 'required',
          name: 'first-name',
          type: 'text',
          editable: true,
        },
        {
          validation: 'required',
          name: 'last-name',
          type: 'text',
          editable: true,
        },

        {
          validation: 'required',
          name: 'mobile-phone-number',
          type: 'tel',
          editable: true,
        },

        {
          name: 'additional-phone-number',
          type: 'tel',
          editable: true,
        },
        {
          validation: 'required',
          name: 'identical-number',
          type: 'text',
          editable: false,
        },
        {
          validation: 'required',
          name: 'city',
          type: 'text',
          editable: true,
        },
        {
          validation: 'required',
          name: 'street',
          type: 'text',
          editable: true,
        },
        {
          validation: 'required',
          name: 'house-number',
          type: 'text',
          editable: true,
        },
        {
          validation: 'required',
          name: 'apartment-number',
          type: 'text',
          editable: true,
        },
        {
          validation: 'required',
          name: 'birthday-date',
          type: 'text',
          editable: true,
        },
        {
          validation: 'required',
          name: 'email',
          type: 'text',
          editable: true,
        },
        {
          //validation: 'required',
          name: 'policeOwnerGender',
          type: 'select',
          options: [
            {key: '1', value: 'זכר'},
            {key: '2', value: 'נקבה'},
          ],
          editable: true,
          readOnly: false
        },
        {
          name: 'age',
          type: 'text',
          editable: true,
        },
        {
          name: 'firstDriverFirstName',
          type: 'text',
          editable: true,
        },
        {
          name: 'firstDriverLastName',
          type: 'text',
          editable: true,
        },
        {
          name: 'firstDriverTz',
          type: 'text',
          editable: true,
        },
        {
          name: 'firstDriverYearBirth',
          type: 'text',
          editable: true,
        },
        {
          name: 'firstDriverGender',
          type: 'select',
          options: [
            {key: '1', value: 'זכר'},
            {key: '2', value: 'נקבה'},
          ],
          editable: true,
        },
        {
          name: 'firstDriverLicenceYear',
          type: 'text',
          editable: true,
        },
        {
          name: 'secondDriverFirstName',
          type: 'text',
          editable: true,
        },
        {
          name: 'secondDriverLastName',
          type: 'text',
          editable: true,
        },
        {
          name: 'secondDriverTz',
          type: 'text',
          editable: true,
        },
        {
          name: 'secondDriverYearBirth',
          type: 'text',
          editable: true,
        },
        {
          name: 'secondDriverGender',
          type: 'select',
          options: [
            {key: '1', value: 'זכר'},
            {key: '2', value: 'נקבה'},
          ],
          editable: true,
        },
        {
          name: 'secondDriverLicenceYear',
          type: 'text',
          editable: true,
        },
        {
          name: 'thirdDriverFirstName',
          type: 'text',
          editable: true,
        },
        {
          name: 'thirdDriverLastName',
          type: 'text',
          editable: true,
        },
        {
          name: 'thirdDriverTz',
          type: 'text',
          editable: true,
        },
        {
          name: 'thirdDriverYearBirth',
          type: 'text',
          editable: true,
        },
        {
          name: 'thirdDriverGender',
          type: 'select',
          options: [
            {key: '1', value: 'זכר'},
            {key: '2', value: 'נקבה'},
          ],
          editable: true,
        },
        {
          name: 'thirdDriverLicenceYear',
          type: 'text',
          editable: true,
        },

        {
          name: 'license-year',
          type: 'text',
          editable: false,
        },
        {
          name: 'license-year',
          type: 'text',
          editable: false,
        },
        {
          name: 'insurance-date-start',
          type: 'text',
          editable: false,
        }
      ],
      ongoingTreatmentObject: {
        ongoingTreatment1: ['הערות הזמנה', 'סטטוס הזמנה', 'כללי', 'הפקה', 'תשלום', 'שינוי סטטוס', 'חידושים'],
        //ongoingTreatment2: ['סטטוס הזמנה'],
        ongoingTreatment2: ['עבר ביטוחי'],
        ongoingTreatment3: ['מיגון'],
        ongoingTreatment4: ['ביטול'],
        ongoingTreatment5: ['שינויים'],
        ongoingTreatment6: ['גביה'],
        ongoingTreatment7: ['תביעות'],
      },

      editNoteObj: {
        id: '',
        note: ''
      },
      isRenewalOfExistingInsurance: false,
      allProductsList: [],
      selectedProduct: '',
      selectedCompany: '',
      selectedDescription: '',

    }
  },

  watch: {
    $route() {
      this.dataReady = false
      this.appendData()
    },
    selectedProduct() {
      this.selectedCompany = '';
      this.selectedDescription = '';
    },
    selectedCompany() {
      this.selectedDescription = '';
    },
    'baseInfo.modeSource'() {
      this.updateLogo();
    },
    'mainForm.dashboard_groups'(newGroups) {
      if (this.isTable(['users']) && this.originalStatuses && this.originalStatuses.length > 0) {
        if (!newGroups || typeof newGroups !== 'string' || newGroups.trim() === '') {
          this.options.statuses = [];
          return;
        }

        const selectedGroupIds = newGroups.split(',').map(id => id.trim());
        const groupedStatuses = [];

        selectedGroupIds.forEach(groupId => {
          // Find group name dynamically from options
          let groupName = groupId;

          // Check both statuses_groups (from table-config) and dashboard_groups as fallback
          const groupOptions = this.options.statuses_groups || this.options.dashboard_groups;

          if (groupOptions && Array.isArray(groupOptions)) {
            // Search by key (numeric ID) OR by the descriptive key (e.g. 'ordersProtect')
            const groupObj = groupOptions.find(g =>
              (g.key && g.key.toString() === groupId.toString()) ||
              (g.id && g.id.toString() === groupId.toString()) ||
              (g.name_key && g.name_key === groupId)
            );
            if (groupObj) groupName = groupObj.value;
          }

          const statusesInGroup = this.originalStatuses.filter(status => {
            if (!status || !status.group_id) return false;
            const statusGroups = status.group_id.toString().split(',').map(sg => sg.trim());
            return statusGroups.includes(groupId.toString());
          }).map(status => {
            return {
              ...status,
              key: `${status.key}_${groupId}`
            };
          });

          if (statusesInGroup.length > 0) {
            groupedStatuses.push({
              label: groupName,
              values: statusesInGroup
            });
          }
        });

        this.options.statuses = groupedStatuses;
      }
    }
  },

  methods: {
    toggleMessageChannel(channel) {
      // channel: 'email', 'sms', 'whatsapp'
      if (channel === 'email') {
        this.msg.isEmail = !this.msg.isEmail;
      } else if (channel === 'sms') {
        this.msg.isSms = !this.msg.isSms;
      } else if (channel === 'whatsapp') {
        this.msg.isWhatsapp = !this.msg.isWhatsapp;
      }
      this.$forceUpdate();
    },
    updateMessageData(data) {
      console.log('updateMessage')
      console.log(data)
      // Update mainForm with the edited data from the message form
      this.mainForm = {...data};
      // Call validateForm to save the changes
      this.validateForm('mainForm', this.baseInfo['statusId']);
    },
    openPopup() {
      this.popupData = "Dynamic data loaded here";
      this.isPopupOpen = true;
    },
    closePopup() {
      this.isPopupOpen = false;
    },
    isTable(tables) {
      return tables.includes(this.$route.query.table)
    },
    checkIfStatusChanged(statusChanged) {
      this.isStatusChanged = statusChanged;
    },
    allowFileUpdate(e, ref) {
      if (this.$refs[`file_${ref}_title`][0].innerHTML.trim()) {
        this.fileUpdateId = ref
        this.$refs[`file_${ref}_update`][0].classList.remove('d-none')
      } else {
        this.fileUpdateId = ''
        this.$refs[`file_${ref}_update`][0].classList.add('d-none')
      }
    },
    // Handle tabs
    isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    isOngoingTreatmentActive(menuItem) {
      return this.activeOngoingTreatmentItem === menuItem;
    },
    setOngoingTreatment(item, label) {
      this.activeOngoingTreatmentItem = item;
      this.activeOngoingTreatmentLabel = label;
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    },

    setActive(menuItem) {
      if (menuItem === 'messages') {
        this.$refs.msgType.value = '';
        this.msg.address = ' ';
        this.msg.subject = ' ';
        this.msg.content = ' ';
        this.msg.smsContent = ' ';
        this.msg.whatsappContent = ' ';
        this.msg.whatsappTemplateName = ' ';
        this.msg.smsPhoneNumber = ' ';
        this.msg.replayTo = ' ';
        this.msg.isEditable = false;
        this.msg.isEditFile = false;
        this.msg.isWhatsapp = false;
        this.msg.isSms = false;
        this.msg.isEmail = false;
        this.msg.isRequiredPhoneBook = false;
        this.msg.autoSend = 0
      }
      this.activeItem = menuItem;
    },
    openMail(mail, firstName, lastName, licenseNumber) {
      window.location.href = "mailto:" + mail + '?bcc=scan.hova@gmail.com' + '&subject=' + firstName + ' ' + lastName + ' ' + licenseNumber;
    },
    editFile(e, action) {
      let data
      if (action === 'update') {
        data = {
          title: this.$refs[`file_${e}_title`][0].innerHTML.trim(),
          //description: this.$refs[`file_${e}_description`][0].innerHTML.trim()
        }
      }

      axios.post(`/fileUpload/${action}/${e}`, data ? data : '')
        .then((res) => {
          this.$emit('alert', 'success', 'File have been modified')
          this.$refs[`file_${this.fileUpdateId}_update`][0].classList.add('d-none')
          this.appendData()
        }).catch((err) => {
        this.$emit('alert', 'danger', err.response.data.status)
      }).finally(() => {
        this.appendData()
      })
    },

    openDraft(e, id) {
      const url = window.location.href;
      const urlSplit = url.split('&');
      const draftURL = `${urlSplit[0]}&id=${id}`;
      window.open(draftURL);
    },

    openUrl(e, id, model = null) {
      const url = window.location.href.replace('clients', model);
      const urlSplit = url.split('&');
      const draftURL = `${urlSplit[0]}&id=${id}`;
      window.open(draftURL);
    },

    async updateInsurance(e, action, ins_order, type = null, car = null, modeSource = null) {
      let url;

      //user = this.state.auth_user;
      if (action === 'order') {
        switch (this.$store.getters.isHostName) {
          case 'localhost':
            // url = "http://stage2.hova.co.il?i_type=" + type + "&" + 'ci=1' + "&" + 'oi=' + this.$route.query.id + "&";
            url = "https://10b.co.il/test/calc/?i_type=" + type + "&" + 'ci=1' + "&" + 'oi=' + this.$route.query.id + "&" + 'aff=' + this.$store.getters.userId + "&";
            break;
          case '10front-stage.hova.co.il':
            // url = "http://stage2.hova.co.il/calc/?i_type=" + type + "&" + 'ci=1' + "&" + 'oi=' + this.$route.query.id + "&";
            url = "https://10b.co.il/test/calc/?i_type=" + type + "&" + 'ci=1' + "&" + 'oi=' + this.$route.query.id + "&" + 'aff=' + this.$store.getters.userId + "&";
            break;
          default:
            url = "https://10b.co.il/web/calc/?i_type=" + type + "&" + 'ci=1' + "&" + 'oi=' + this.$route.query.id + "&" + 'aff=' + this.$store.getters.userId + "&";
        }

      } else {
        switch (this.$store.getters.isHostName) {
          case 'localhost':
            url = "https://10b.co.il/test/הזמנת_ביטוח_חובה/?p=1&ei=1&orderId=" + this.$route.query.id + "&";
            break;
          case '10front-stage.hova.co.il':
            url = "https://10b.co.il/test/הזמנת_ביטוח_חובה/?p=1&ei=1&orderId=" + this.$route.query.id + "&";
            break;
          default:
            url = "https://10b.co.il/web/הזמנת_ביטוח_חובה/?p=1&ei=1&orderId=" + this.$route.query.id + "&";
        }

      }

      url = url + "src=1&ai=" + this.$store.getters.userId + "&ins_order=" + ins_order + "&car=" + car;

      // Only hova needs to verify this click came from a real agent (its own agent-only renewal
      // gate) - 10b is a separate external site, out of scope here.
      if (modeSource !== '10b') {
        try {
          const res = await axios.post('issueRenewalLinkToken');
          url += `&rtoken=${res.data.token}`;
        } catch (e) {
          this.$emit('alert', 'error', 'לא ניתן היה לאמת את המשתמש, נסה שוב');
          return;
        }
      }

      window.open(url)
    },
    duplicateOrder(e, id) {
      if (id) {
        axios.get(`/${this.routeName}/duplicateOrder/${id}`)
          .then((res) => {
            this.$emit('alert', 'success', 'Duplicate Success');
            this.appendData()
          }).catch((err) => {
          this.$emit('alert', 'danger', err.response.data.data.error)
        })
      }
    },

    addNoteProductStatus(row) {
      let statusSubject = row;
      let msgContent = '';
      //translate old value
      /*for (let i in this.productsStatuses) {
        msgContent += this.productsStatuses[i].value;
      }*/
      //translate new value
      for (let i in this.productsStatuses) {
        msgContent += ' > ' + this.productsStatuses[i].value;
      }

      let data = {
        subject: 'עדכון סטטוס',
        description: msgContent
      };

      let req = axios.post(`${this.routeName}/addNote/${this.$route.query.id}`, data);

      if (alert) {
        req.then((res) => {
          this.$emit('alert', 'success', 'Note added');
          e.target.reset();
          this.appendData()
        }).catch((err) => {
          this.$emit('alert', 'danger', err.response.data.data.error)
        })
      }
    },
    updateStatus(type) {

      let msgContent = '';

      // old value
      let comperar = '';
      let optionKey = '';
      let noteName = '';

      switch (type) {
        case 'orderStatus':
          comperar = 'statusId';
          optionKey = 'statuses';
          noteName = 'סטטוס הזמנה'
          break;
        case 'lackOfClaimsStatus':
          comperar = 'lackOfClaimsStatus';
          optionKey = 'lackOfClaims';
          noteName = 'עבר ביטוחי';
          break;
        case 'paymentStatus':
          comperar = 'paymentStatus';
          optionKey = 'paymentStatus';
          noteName = 'גביה'
          break;
        case 'changesStatus':
          comperar = 'changesStatus';
          optionKey = 'changesStatus';
          noteName = 'שינויים'
          break;
        case 'claimsStatus':
          comperar = 'claimsStatus';
          optionKey = 'claimsStatus';
          noteName = 'תביעות'
          break;
        case 'policyStatus':
          comperar = 'policyStatus';
          optionKey = 'policyStatus';
          noteName = 'ביטול'
          break;
        case 'protectiveStatus':
          comperar = 'protectiveStatus';
          optionKey = 'protectionStatus';
          noteName = 'מיגון';
          break;
        case 'renewalStatus':
          comperar = 'renewalStatus';
          optionKey = 'renewalsStatus';
          noteName = 'חידושים';
          break;
      }


      //translate old value
      for (let i in this.options[optionKey]) {
        if (this.options[optionKey][i].key == this.baseInfo[comperar]) {
          msgContent += this.options[optionKey][i].value
        }
      }
      //translate new value
      for (let i in this.options[optionKey]) {
        if (this.options[optionKey][i].key == this.$refs[type].value) {
          msgContent += ' > ' + this.options[optionKey][i].value
        }
      }

      let notInfo = {
        subject: noteName,
        description: msgContent
      }

      let data = {
        statusType: type,
        selectedStatusId : parseInt(this.$refs[type].value)
      };

      this.shouldBlockInteraction = true
      let that = this;


      axios.post(`/orders/checkIfNeedToSendAutoMessage/${this.$route.query.id}`, data)
        .then((res) => {
          data.isConfirmedToSend = false;
          if(res.data && res.data.data && res.data.data.res && res.data.data.res.isAutoMessage) {
            const name = res.data.data.res.name
            data.isConfirmedToSend = confirm(`שינוי הסטטוס ישלח ללקוח הודעה מסוג ${name} - האם לשלוח הודעה ? `)
          }
          // Now update the status
          return axios.post(`/orders/updateStatus/${this.$route.query.id}`, data)
        })
        .then((res) => {
          that.$emit('alert', 'success', 'Status updated')
          that.addNewNoteQuery(notInfo);
          if (that.isRenewalsSource) {
            that.updateRenewalStatus();
          }
        })
        .catch((err) => {
          this.$emit('alert', 'danger', err.response.data.data.error)
        })

      // if(type === 'orderStatus') {
      //   axios.post(`/orders/checkIfNeedToSendAutoMessage/${this.$route.query.id}`, data)
      //     .then((res) => {
      //       data.isConfirmedToSend = false;
      //       if(res.data && res.data.data && res.data.data.res && res.data.data.res.isAutoMessage) {
      //         const name = res.data.data.res.name
      //         data.isConfirmedToSend = confirm(`שינוי הסטטוס ישלח ללקוח הודעה מסוג ${name} - האם לשלוח הודעה ? `)
      //       }
      //       // Now update the status
      //       return axios.post(`/orders/updateStatus/${this.$route.query.id}`, data)
      //     })
      //     .then((res) => {
      //       that.$emit('alert', 'success', 'Status updated')
      //       that.addNewNoteQuery(notInfo);
      //       if (that.isRenewalsSource) {
      //         that.updateRenewalStatus();
      //       }
      //     })
      //     .catch((err) => {
      //       this.$emit('alert', 'danger', err.response.data.data.error)
      //     })
      // } else {
      //     axios.post(`/orders/updateStatus/${this.$route.query.id}`, data)
      //       .then((res) => {
      //         that.$emit('alert', 'success', 'Status updated')
      //         that.addNewNoteQuery(notInfo);
      //         if (that.isRenewalsSource) {
      //           that.updateRenewalStatus();
      //         }
      //       })
      //       .catch((err) => {
      //         this.$emit('alert', 'danger', err.response.data.data.error)
      //       })
      // }



    },
    addNewNote(e, alert = true, validate = true, type) {
      this.$validator.validateAll(validate ? 'note' : '').then(result => {
        if (result) {
          let statusSubject = '';
          switch (type) {
            case 'orderStatus':
              statusSubject = this.$t('orders.updateStatus');
              break;
            case 'lackOfClaimsStatus':
              statusSubject = this.$t('orders.historyInsurance');
              break;
            case 'protectiveStatus':
              statusSubject = this.$t('orders.protective');
              break;
            case 'renewalStatus':
              statusSubject = 'חידושים';
              break;
            default:
          }

          let data = {
            subject: statusSubject ? statusSubject : e.target[0].value,
            description: e.msg ? e.msg : e.target[1].value
          }
          console.log(data)
          console.log('data')
          return;

          this.addNewNoteQuery(data);
          // let req = axios.post(`${this.$route.query.table}/addNote/${this.$route.query.id}`, data)
          //
          // if (alert) {
          //   req.then((res) => {
          //     this.$emit('alert', 'success', 'Note added')
          //     e.target.reset()
          //     this.appendData()
          //   }).catch((err) => {
          //     this.$emit('alert', 'danger', err.response.data.data.error)
          //   })
          // }
        }
      })
    },

    prepareManualComment(e) {

      let data = {
        subject: e.target[0].value,
        description: e.target[1].value,
        isHighlightNote: this.isChecked
      }

      if (!data) {
        return;
      }
      if (!this.editNoteObj.id) {
        this.addNewNoteQuery(data);
      } else {
        this.updateNoteQuery(data, this.editNoteObj.id);

      }


    },
    addNewNoteQuery(data) {
      if (!data) {
        return;
      }
      this.shouldBlockInteraction = true;
      let that = this;
      let req = axios.post(`${this.routeName}/addNote/${this.$route.query.id}`, data)
        .then((res) => {
          // Reset form by clearing inputs
          if (that.$refs.noteForm) {
            const inputs = that.$refs.noteForm.querySelectorAll('input, textarea');
            inputs.forEach(input => {
              input.value = '';
            });
          }
          setTimeout(() => {
            that.$emit('alert', 'success', 'Note added')
            that.shouldBlockInteraction = false;
          }, 2000)
          that.appendData()
        }).catch((err) => {
          that.$emit('alert', 'danger', err.response.data.status)
        })
    },

    updateNoteQuery(data, id) {
      if (!id) {
        return;
      }
      let req = axios.post(`${this.routeName}/updateNote/${id}`, data)
        .then((res) => {
          this.$emit('alert', 'success', 'Note updated')
          this.$refs.noteForm.reset(); // <<< rest form
          this.appendData()
        }).catch((err) => {
          this.$emit('alert', 'danger', err.response.data.status)
        })
    },
    editNote(id, description) {
      if (id) {
        this.editNoteObj.id = id;
        this.editNoteObj.note = description;

      }
    },
    isAllowToEdit(inputTime) {
      const inputDate = new Date(inputTime);
      const now = new Date();

      const diffInMs = Math.abs(now - inputDate);
      const diffInMinutes = diffInMs / 1000 / 60;

      return diffInMinutes <= 5;
    },
    // Add new product
    addNewProduct(e, alert = true, validate = true) {
      let that = this;
      let data = {
        productName: this.productSelectedRow.productName,
        companyName: this.productSelectedRow.companyName,
        price: this.productSelectedRow.price.toString(),
        numberOfPayment: this.productSelectedRow.selectedInstallment,
        startDate: this.baseInfo['insurance-date-start'],
        endDate: this.baseInfo['insurance-date-finish'],
        policyNumber: this.productSelectedRow.policyNumber,
        status: 1,
        comments: e.product ? e.product : this.productSelectedRow.comments,
        userName: this.$store.getters.fullUsername ? this.$store.getters.fullUsername : null,
        routeName: 'orders',
        deductible: this.productSelectedRow.deductible,
        debtSettlement: this.productSelectedRow.debtSettlement,
        zadGimelRes: this.productSelectedRow.zadGimelRes,
        maxPay: this.productSelectedRow.maxPay,
        maxInterestFreeInstallments: this.productSelectedRow.maxInterestFreeInstallments,
        description: this.selectedDescription,
        // productFile: e.product ? e.product : this.product.productFile,
      };


      let req = axios.post(`${this.routeName}/addProduct/${this.$route.query.id}`, data);

      if (alert) {
        let that = this;
        req.then((res) => {
          this.$emit('alert', 'success', 'Product added');
          this.appendData();

          // Clear form fields
          this.selectedProduct = '';
          this.selectedCompany = '';
          this.selectedDescription = '';
          this.productSelectedRow = null;

          // Reset form
          if (e.target) {
            e.target.reset();
          }

          // Hide the form
          const collapseElement = document.getElementById('collapseProduct');
          if (collapseElement) {
            const bsCollapse = new bootstrap.Collapse(collapseElement, {
              hide: true
            });
          }
        }).catch((err) => {
          this.$emit('alert', 'danger', err.response.data.data.error)
        })
      }


      /*this.$validator.validateAll(validate ? 'note' : '').then(result => {
        if (result) {

        }
      })*/
    },
    showDescription(description) {
      if (description) {
        this.$emit('alert', 'info', description);
      }
    },
    hideDescription() {
      // Tooltip will hide automatically
    },
    translate(val, key) {
      if (['ins-type'].includes(key)) {
        switch (val) {
          case '2':
            return this.$t('orders.mekif');
            break;
          case '3':
            return this.$t('orders.zadGimel');
            break;
          default:
            return this.$t('orders.hova');
        }
      } else if (['esp', 'fcw', 'ldw', 'keeping-distance-system', 'deviation-system', 'drive-on-saturday', 'mortgaged', 'law-suites-3-year', 'keeping-distance-system', 'license-suspensions'].includes(key)) {
        if (val.length === 1) {
          return val === '1' ? this.$t('orders.yes') : this.$t('orders.no')
        } else {
          val = val.replace('1', this.$t('orders.yes')).replace('2', this.$t('orders.no'));
          if (val.includes('0')) {
            val = val.replace('1', this.$t('orders.yes')).replace('0', this.$t('orders.no'));
          }
          return val;

        }

      } else if (['gender', 'policeOwnerGender', 'firstDriverGender', 'secondDriverGender', 'thirdDriverGender'].includes(key)) {
        if (val.length === 1) {
          return val === '1' ? this.$t('orders.male') : this.$t('orders.female')
        } else {
          val = val.replace('1', this.$t('orders.male')).replace('2', this.$t('orders.female'));
          if (val.includes('0')) {
            val = val.replace('1', this.$t('orders.male')).replace('0', this.$t('orders.female'));
          }
          return val;

        }

      } else if (['statusId'].includes(key)) {
        return val == '1' ? 'חדש' : 'בוטל'
      } else if (['insurance-1-year', 'insurance-2-year', 'insurance-3-year'].includes(key)) {
        const map = {
          '1': 'מקיף',
          '2': 'צד ג\'',
          '3': 'לא היה'
        };
        // מחפש כל מספר בין 1 ל־3 ומחליף
        return val.replace(/\b[1-3]\b/g, match => map[match] || match);
      } else {
        return val
      }
    },
    appendData() {

      import('../table-config').then((config) => {
        let tconfig = config.default[this.$route.query.table];
        if (tconfig) {
          this.config = tconfig
        }
      });


      this.routeName = this.routePartOfOrdersGroup() ? 'orders' : this.$route.query.table;

      axios.post(`/${this.routeName}/single/${this.$route.query.id}`, this.$route.query)
        .then((res) => {

          if (res.data.data.row) {
            /* console.log(this.$route.query.table);
            console.log(res.data.data.more_orders.filter((obj) => obj.id != this.$route.query.id)); */
            this.baseInfo = res.data.data.row;
            this.products = res.data.data.products;
            if (this.routePartOfOrdersGroup()) {
              this.more_orders = res.data.data.more_orders.filter((obj) => obj.id != this.$route.query.id);
            }

            this.updatedBy = res.data.data.updatedBy ? res.data.data.updatedBy : '';
            this.options = res.data.data.options || {};

            // Save original statuses for users dashboard filtering
            if (this.isTable(['users'])) {
              const statusesToStore = this.options.allStatuses || this.options.statuses || [];
              this.originalStatuses = Array.isArray(statusesToStore) ? [...statusesToStore] : Object.values(statusesToStore);

              const currentGroups = this.baseInfo.dashboard_groups;
              if (!currentGroups) {
                this.options.statuses = [];
              } else {
                const selectedGroupIds = currentGroups.split(',').map(id => id.trim());
                const groupedStatuses = [];

                selectedGroupIds.forEach(groupId => {
                  let groupName = groupId;

                  const groupOptions = this.options.statuses_groups || this.options.dashboard_groups;

                  if (groupOptions && Array.isArray(groupOptions)) {
                    const groupObj = groupOptions.find(g =>
                      (g.key && g.key.toString() === groupId.toString()) ||
                      (g.id && g.id.toString() === groupId.toString()) ||
                      (g.name_key && g.name_key === groupId)
                    );
                    if (groupObj) groupName = groupObj.value;
                  }

                  const statusesInGroup = this.originalStatuses.filter(status => {
                    if (!status || !status.group_id) return false;
                    const statusGroups = status.group_id.toString().split(',').map(sg => sg.trim());
                    return statusGroups.includes(groupId.toString());
                  }).map(status => {
                    return {
                      ...status,
                      key: `${status.key}_${groupId}`
                    };
                  });

                  if (statusesInGroup.length > 0) {
                    groupedStatuses.push({
                      label: groupName,
                      values: statusesInGroup
                    });
                  }
                });

                this.options.statuses = groupedStatuses;
              }
            }

            // Check order is only for readonly
            if (this.baseInfo && this.baseInfo['replicate']) {
              this.shouldBlockInteraction = true;
            }

            if (this.baseInfo['isRenewalOfExistingInsurance'] === '1') {
              this.isRenewalOfExistingInsurance = true;
            }

            if (this.baseInfo['roadServices']) {
              this.roadServicesIndex = this.baseInfo['roadServices'];
            }

            if (this.baseInfo['extensionMoreDetails']) {
              this.extensionMoreDetails = JSON.parse(this.baseInfo['extensionMoreDetails']);
            }

            this.$nextTick(() => {
              setTimeout(() => {
                this.highlightUpdatedCards();
              }, 50); // לפעמים מספיק אפילו 10-20ms
            });


            /*  if(this.updatedBy.length > 0) {
                this.orderUpdateBy = this.updatedBy[0].firstName + ' ' + this.updatedBy[0].lastName;
              }*/


            // Only for messages modal - we concat status group with status name
            if (this.$route.query.table === 'messages') {
              for (let i in this.options.allStatuses) {
                this.options.allStatuses[i].value = this.options.allStatuses[i].value + ' - ' + `(${this.options.allStatuses[i].statusGroup})`
              }
            }

            if (this.options.statuses && this.config.statusGroup) {
              // if is one of the order pages, change statusGroup !!
              let configStatusGroup = this.routeName === 'orders' ? 1 : this.config.statusGroup;

              let arr = [];
              let obj = this.options.statuses;

              for (let i in obj) {
                if (obj[i].statusGroup === configStatusGroup || obj[i].statusGroup === 0) {
                  arr.push(obj[i])
                }
                // find current status value
                if (obj[i].key === parseInt(this.baseInfo['statusId'])) {
                  this.currentStatus['value'] = obj[i].value;
                  this.currentStatus['color'] = obj[i].color;
                }
              }
              this.options.statuses = arr;
            }
            if (this.isRenewalsSource && this.options.renewalsStatus) {
              let obj = this.options.renewalsStatus;

              for (let i in obj) {
                if (obj[i].key === parseInt(this.baseInfo['renewalStatus'])) {
                  this.currentStatus['value'] = obj[i].value;
                  this.currentStatus['color'] = obj[i].color;
                }
              }
            }

            this.notes = res.data.data.notes;
            this.files = res.data.data.files;
            this.drafts = res.data.data.drafts;
            this.replicates = res.data.data.replicates;
            this.customer = res.data.data.customer;
            this.mails = res.data.data.mails;
            this.allMessages = res.data.data.messages;
            //this.messages = res.data.data.messages[this.selectedMessageType];
            this.messages = res.data.data.messages;
            this.isCustomerExists = res.data.data.isCustomerExists;
            this.externalLinks = res.data.data.externalLinks;
            this.roadServicesList = res.data.data.roadServicesList;
            this.allProductsList = res.data.data.productsList;
            this.productsHistory = res.data.data.productsHistory;

            this.statusColorIndex = res.data.data.row['statusId'];
            this.lackOfClaimsColorIndex = res.data.data.row['lackOfClaimsStatus'];
            this.paymentStatusColorIndex = res.data.data.row['paymentStatus'];
            this.policyStatusColorIndex = res.data.data.row['policyStatus'];
            this.changesStatusColorIndex = res.data.data.row['changesStatus'];
            this.claimsStatusColorIndex = res.data.data.row['claimsStatus'];
            this.protectionStatusColorIndex = res.data.data.row['protectiveStatus'];
            this.renewalStatusColorIndex = res.data.data.row['renewalStatus'];


            // Find current lackOfClaims Status value and color
            if (this.options.lackOfClaims) {
              let obj = this.options.lackOfClaims;
              for (let i in obj) {
                if (obj[i].key === parseInt(this.baseInfo['lackOfClaimsStatus'])) {
                  this.currentStatusLackOfClaims['value'] = obj[i].value;
                  this.currentStatusLackOfClaims['color'] = obj[i].color;
                }
              }
            }

            // Find current paymentStatus Status value and color
            if (this.options.paymentStatus) {
              let obj = this.options.paymentStatus;
              for (let i in obj) {
                if (obj[i].key === parseInt(this.baseInfo['paymentStatus'])) {
                  this.currentStatusPayment['value'] = obj[i].value;
                  this.currentStatusPayment['color'] = obj[i].color;
                }
              }
            }

            // Find current policyStatus Status value and color
            if (this.options.policyStatus) {
              console.log('this.options --- ');
              console.log(this.options);
              console.log('this.baseInfo --- ');
              console.log(this.baseInfo);
              let obj = this.options.policyStatus;
              for (let i in obj) {
                if (obj[i].key === parseInt(this.baseInfo['policyStatus'])) {
                  this.currentStatusPolicy['value'] = obj[i].value;
                  this.currentStatusPolicy['color'] = obj[i].color;
                }
              }
            }

            // Find current changesStatus Status value and color
            if (this.options.changesStatus) {
              let obj = this.options.changesStatus;
              for (let i in obj) {
                if (obj[i].key === parseInt(this.baseInfo['changesStatus'])) {
                  this.currentStatusChange['value'] = obj[i].value;
                  this.currentStatusChange['color'] = obj[i].color;
                }
              }
            }

            // Find current claimsStatus Status value and color
            if (this.options.claimsStatus) {
              let obj = this.options.claimsStatus;
              for (let i in obj) {
                if (obj[i].key === parseInt(this.baseInfo['claimsStatus'])) {
                  this.currentStatusClaims['value'] = obj[i].value;
                  this.currentStatusClaims['color'] = obj[i].color;
                }
              }
            }

            // Find current protective Status value and color
            if (this.options.protectionStatus) {
              let obj = this.options.protectionStatus;
              for (let i in obj) {
                if (obj[i].key === parseInt(this.baseInfo['protectiveStatus'])) {
                  this.currentProtectiveStatus['value'] = obj[i].value;
                  this.currentProtectiveStatus['color'] = obj[i].color;
                }
              }
            }
          }

          /**
           * Append fields data dynamically on data mainForm object when data is ready
           */
          let obj = new Object()
          if (this.config.schema) {
            for (let i in this.config.schema) {
              obj[this.config.schema[i].name] = this.baseInfo[this.config.schema[i].name]
            }
            this.mainForm = obj
          }

          this.updateLogo()
          this.dataReady = true
        }).catch((err) => {
        this.$emit('alert', 'danger', err.response.data.status)
      })

    },
    highlightUpdatedCards() {
      $('.card .card-body span.font-weight-bold').each(function () {
        const $el = $(this);
        const text = $el.text().trim();

        if (text.includes('עודכן')) {
          $el.css('background-color', 'yellow');
        }
      });
    },
    routePartOfOrdersGroup() {
      let ordersPages = ['orders', 'ordersControl', 'ordersProtect', 'ordersCancellations', 'ordersCollection', 'ordersTasks', 'ordersClaims']
      return ordersPages.includes(this.$route.query.table);
    },
    getItemStyles(index) {
      const item = this.more_orders[index];
      return {
        color: item['status_color'],
        border: '3px solid' + item['status_color'],
        borderRadius: '30px',
        padding: '10px'
        // Add other style properties here
      };
    },
    getLink(index) {
      const item = this.more_orders[index];
      return 'view?table=orders&id=' + item['id'];
    },
    validateForm(scope, oldStatusValue) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          let that = this;
          let data = {'objectInfo': this.mainForm};

          axios.post(`/${this.routeName}/update/${this.$route.query.id}`, data)
            .then((res) => {
              that.addNoteAfterStatusUpdate(res, oldStatusValue);

              that.$emit('alert', 'success', 'Row updated');
              that.appendData(data)
            })
            .catch((err) => {
              console.log(err.response.data.data.error);
              this.$emit('alert', 'danger', err.response.data.data.error)
            })
        } else {
          this.$emit('alert', 'danger', 'Form data is incomplete')
        }
      })
    },

    addNoteAfterStatusUpdate(res, oldStatusValue) {
      //translate old value
      let msgContent = '';
      for (let i in this.options['statuses']) {
        if (this.options['statuses'][i].key == oldStatusValue) {
          msgContent += this.options['statuses'][i].value
        }
      }
      //translate new value
      for (let i in this.options['statuses']) {
        if (this.options['statuses'][i].key == res.data.data.row['statusId']) {
          msgContent += ' > ' + this.options['statuses'][i].value
        }
      }

      const note = {
        sub: this.$t('orders.general'),
        msg: msgContent
      };

      this.addNewNote(note, false, false, 'orderStatus');
    },
    requestStatus(e) {
      if (this.$refs.statusType.value) {
        this.product.status = this.$refs.statusType.value;
      }
    },
    requestCompanies(name) {
      if (name === 'productName') {
        this.product.productName = this.$refs.productsNames.value;
      } else if (name === 'companyName') {
        this.product.companyName = this.$refs.companiesNames.value;
      }
    },

    requestMsg() {
      let id = this.$refs.msgType.value;

      for (let i in this.messages) {
        if (id == '') {
          this.msg.messageId = ' ';
          this.msg.address = ' ';
          this.msg.subject = ' ';
          this.msg.content = ' ';
          this.msg.smsContent = ' ';
          this.msg.smsPhoneNumber = ' ';
          this.msg.replayTo = ' ';
          this.msg.isEditable = 0;
          this.msg.autoSend = 0;
          this.msg.isSms = 0;
          this.msg.isWhatsapp = 0;
          this.msg.isEmail = 0;
          this.msg.isRequiredPhoneBook = 0;
        }
        if(id === '0000'){
          this.msg.messageId = '0000';
          this.msg.address = '';
          this.msg.secondMailAddress = '';
          this.msg.subject = '';
          this.msg.content = '';
          this.msg.replayTo = '';
          this.msg.isEditable = false;
          this.msg.autoSend = 0;
          this.msg.isSms = true;
          this.msg.isWhatsapp = false;
          this.msg.isEmail = true;
          this.msg.isRequiredPhoneBook = false;


          this.msg.whatsappContent = '';
          this.msg.smsContent = '';
          this.msg.smsPhoneNumber = '';
          this.msg.files = '';
        } else {
          if (this.messages[i].id === parseInt(id)) {

            this.msg.messageId = parseInt(id)
            this.msg.address = this.messages[i].address;
            this.msg.secondMailAddress = this.messages[i].secondMailAddress;
            this.msg.subject = this.messages[i].subject;
            this.msg.content = this.messages[i].content;
            this.msg.replayTo = this.messages[i].replayTo;
            this.msg.isEditable = this.messages[i].isEditable ? true : false;
            this.msg.autoSend = this.messages[i].autoSend ? this.messages[i].autoSend : 0;
            this.msg.isSms = this.messages[i].isSms;
            this.msg.isWhatsapp = this.messages[i].isWhatsapp;
            this.msg.isEmail = this.messages[i].isEmail;
            this.msg.whatsappContent = this.messages[i].whatsappContent;
            this.msg.smsContent = this.messages[i].smsContent;
            this.msg.smsPhoneNumber = this.messages[i].smsPhoneNumber;
            this.msg.files = this.messages[i].files;
            this.msg.isEditFile = this.messages[i].isEditFile;
            this.msg.isRequiredPhoneBook = this.messages[i].isRequiredPhoneBook;
          }
        }




      }
    },

    sendMsg() {
      // start loader
      this.dataTableReady = true;
      this.isButtonClicked = true;
      let id = this.$route.query.id;

      this.msg.routeName = this.routeName;
      let that = this;

      // Validate email
      if(this.msg.isEmail) {
        if(!this.msg.content || !this.msg.subject) {
          this.dataTableReady = false;
          this.isButtonClicked = false;
          this.$emit('alert', 'danger', 'שגיאה - בדוק את השדות')
          return;
        }
        if (this.msg.isEditFile) {
          // if we don't have file
          if(!this.msg.files) {
            this.dataTableReady = false;
            this.isButtonClicked = false;
            this.$emit('alert', 'danger', 'שגיאה - יש לצרף קובץ')
            return;
          }
        }


        if(this.msg.isRequiredPhoneBook) {
          if(!this.msg.phoneBookAddress || !this.msg.phoneBookAddress.length) {
            this.dataTableReady = false;
            this.isButtonClicked = false;
            this.$emit('alert', 'danger', 'שגיאה - חייב לבחור איש קשר מהרשימה')
            return;
          }

        }
      }

      // Validate sms
      if(this.msg.isSms) {
        if(!this.msg.smsContent ) {
          this.dataTableReady = false;
          this.isButtonClicked = false;
          this.$emit('alert', 'danger', 'שגיאה - בדוק את השדות')
          return;
        }
      }
      // Validate email
      if(this.msg.isWhatsapp) {
        if(!this.msg.whatsappContent ||  !this.msg.whatsappTemplateName) {
          this.dataTableReady = false;
          this.isButtonClicked = false;
          this.$emit('alert', 'danger', 'שגיאה - בדוק את השדות ושם הטמפלט')
          return;
        }
      }

      if(this.msg.secondMailAddress ) {
        if(this.msg.phoneBookAddress.length === 0) {
          this.dataTableReady = false;
          this.isButtonClicked = false;
          this.$emit('alert', 'danger', 'שגיאה - יש לבחור איש קשר')
          return;
        }
        // After we validate we have phoneBookAddress we reset param
        this.msg.secondMailAddress = '';
      }



      this.shouldBlockInteraction = true;
      // if we don't need to add file
      axios.post(`${this.routeName}/sendMail/${this.$route.query.id}`, this.msg)
        .then((res) => {
          that.dataTableReady = false;
          that.shouldBlockInteraction = false;
          that.isButtonClicked = false;
          that.appendData();
          that.msg = this.getDefaultMsg(); // איפוס האובייקט
          that.$emit('alert', 'success', 'Message sent');

          that.$refs.msgType.selectedIndex = 0;
          that.dataReady = true
        }).catch((err) => {
        that.dataTableReady = false;
        that.isButtonClicked = false;
        that.shouldBlockInteraction = false;
        that.$emit('alert', 'danger', err.response.data.status)
      })
    },

    sendMsg_OLD() {

      let body = '';
      if (this.selectedMessageType === 'sms' || this.selectedMessageType === 'whatsapp') {
        body = $('#smsBody').val();
      } else if (this.selectedMessageType === 'emails') {
        body = $('#body').val();
      }

      if (!body) {
        return this.$emit('alert', 'danger', 'יש למלא את גוף ההודעה')
      }

      // start loader
      this.dataTableReady = true;
      this.isButtonClicked = true;
      let id = this.$route.query.id;

      if (this.msg.autoSend) {
        this.msg.phone = this.msg.autoSend === 2 ? this.baseInfo['mobile-phone-number'] : ''
      }
      if (this.msg.phoneBookAddress) {
        this.msg.address = this.msg.phoneBookAddress ? this.msg.phoneBookAddress : this.msg.address;
      }


      if (this.msg.autoSend === 0 && !this.msg.isWhatsapp) {
        if (this.msg.address === null && this.msg.secondMailAddress === null) {
          this.dataTableReady = false;
          this.isButtonClicked = false;
          //this.$emit('alert', 'danger', 'Error - you need to add address');
          return;
        }
      }

      this.msg.routeName = this.routeName;
      let that = this;
      // if we need to add file
      if (this.msg.isEditFile) {
        // if file added
        if (this.msg.files) {
          this.shouldBlockInteraction = true;

          // axios.post(`${this.routeName}/sendMail/${this.$route.query.id}`, this.msg)
          //   .then((res) => {
          //     that.dataTableReady = false;
          //     that.shouldBlockInteraction = false;
          //     that.appendData();
          //     that.msg = this.getDefaultMsg(); // איפוס האובייקט
          //     that.$emit('alert', 'success', 'Message sent');
          //     that.$refs.msgType.selectedIndex = 0;
          //     that.dataReady = true
          //   }).catch((err) => {
          //   that.shouldBlockInteraction = false;
          //   that.dataTableReady = false;
          //   that.isButtonClicked = false;
          //   that.$emit('alert', 'danger', err.response.data.status)
          // })

        } else {
          // if we don't add file
          this.dataTableReady = false;
          this.isButtonClicked = false;
          this.$emit('alert', 'danger', 'Error - check your fields')
        }
      } else {
        this.shouldBlockInteraction = true;

        // if we don't need to add file
        axios.post(`${this.routeName}/sendMail/${this.$route.query.id}`, this.msg)
          .then((res) => {
            that.dataTableReady = false;
            that.shouldBlockInteraction = false;
            that.isButtonClicked = false;
            that.appendData();
            that.msg = this.getDefaultMsg(); // איפוס האובייקט
            that.$emit('alert', 'success', 'Message sent');

            that.$refs.msgType.selectedIndex = 0;
            that.dataReady = true
          }).catch((err) => {
          that.dataTableReady = false;
          that.isButtonClicked = false;
          that.shouldBlockInteraction = false;
          that.$emit('alert', 'danger', err.response.data.status)
        })
      }
    },
    editOrder(e) {
      this.saveButton = true;
      this.isCreditUpdate = false;

      const controls = this.$refs.editOrder;

      // ודא שמדובר במערך
      const controlList = Array.isArray(controls) ? controls : [controls];

      controlList.forEach(control => {
        if (!control || !control.$el) return;

        // אלמנט DOM של הקומפוננטה
        const el = control.$el;

        // נסיר את המחלקה 'd-none' ונאפס display
        el.classList.remove('d-none');
        el.style.display = '';

        // לוג לבדיקה
        //console.log('נחשף:', el);
      });
    },


    orderCancelEdit(e) {
      this.saveButton = false;
      this.isCreditUpdate = true;

      const controls = Array.isArray(this.$refs.editOrder)
        ? this.$refs.editOrder
        : [this.$refs.editOrder];

      controls.forEach(control => {
        if (!control || !control.$el) return;

        const el = control.$el;

        // הסתרת כל הטופס
        el.classList.add('d-none');
        el.style.display = 'none';
      });

      this.appendData();
    },

    orderSaveEdit(row) {
      this.$validator.validateAll(row).then((result) => {
        if (result) {
          row['updatedByUserName'] = this.$store.getters.fullUsername;
          var today = new Date();
          var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
          var dateTime = date + ' ' + time;
          row['updatedByUser_at'] = dateTime;

          let rawData = {...row};
          //delete rawData['updated_at'];
          delete rawData['created_at'];
          delete rawData['id'];
          let data = {'objectInfo': rawData};
          this.shouldBlockInteraction = true;
          let that = this;
          axios.post(`/${this.routeName}/update/${this.$route.query.id}`, data)
            .then((res) => {
              this.orderCancelEdit();
              if (res.data.data.replicateId) {
                that.updateRowInHova(res.data.data.replicateId);
              }
              that.$emit('alert', 'success', 'Row updated');
              that.shouldBlockInteraction = false;
              that.getAll()
            })
            .catch((err) => {
              this.shouldBlockInteraction = false;
              that.$emit('alert', 'danger', err.response.data.data.error)
            })
        }
      })
      this.isCreditUpdate = true;

    },
    updateRowInHova(id) {
      axios.post(`/${this.routeName}/updateHovaRow/${id}`)
        .then((res) => {
        })
        .catch((err) => {

        })
    },
    editProduct(product, row) {
      // אם יש עריכה פעילה בשורה אחרת, בטל אותה
      if (this.inRowEdit !== '' && this.inRowEdit !== row) {
        this.cancelEdit(this.inRowEdit);
      }

      this.inRowEdit = row;

      // טיפול בשדות הרגילים
      for (let item in this.config.productsSchema) {
        if (this.config.productsSchema[item].editable) {
          let el = this.$refs[row + '_' + this.config.productsSchema[item].name];
          let formControl = this.$refs[`form_${row}_${this.config.productsSchema[item].name}`];

          if (el && el.length > 0) {
            // הסתר את הטקסט הרגיל
            el[0].classList.add('d-none');
            // הצג את שדה העריכה
            if (formControl && formControl.length > 0) {
              formControl[0].$el.classList.remove('d-none');
            }
          }
        }
      }


    },
    cancelEdit(rowId) {
      this.appendData();

      // אם לא קיבלנו rowId, נשתמש ב־this.inRowEdit
      const row = rowId || this.inRowEdit;

      // טיפול בשדות הרגילים
      for (let item in this.config.productsSchema) {
        if (this.config.productsSchema[item].editable) {
          let el = this.$refs[row + '_' + this.config.productsSchema[item].name];
          let formControl = this.$refs[`form_${row}_${this.config.productsSchema[item].name}`];

          if (el && el.length > 0) {
            // הצג את הטקסט הרגיל
            el[0].classList.remove('d-none');
            // הסתר את שדה העריכה
            if (formControl && formControl.length > 0) {
              formControl[0].$el.classList.add('d-none');
            }
          }
        }
      }


      this.inRowEdit = '';
    },


    doneEdit(row, id) {
      this.$validator.validateAll(row).then((result) => {
        if (result) {
          let rawData = {...row};
          delete rawData['updated_at'];
          delete rawData['created_at'];
          delete rawData['id']
          let data = {'objectInfo': rawData};

          // TODO:: Ask oren
          //this.addNoteProductStatus(rawData);

          data.objectInfo.updatedByUser = this.$store.getters.fullUsername;

          axios.post(`/${this.routeName}/updateProduct/${row.id}`, data)
            .then((res) => {
              this.cancelEdit(this.inRowEdit);
              // this.rows[rowId - 1] = res.data.data.row
              this.$emit('alert', 'success', 'Success');
              this.appendData()
            })
            .catch((err) => {
              this.$emit('alert', 'danger', err.response.data.status)
            })
        }

      })
    },
    print() {
      this.$router.push({
        path: '/print', query: {
          'firstName': this.baseInfo['first-name'],
          'lastName': this.baseInfo['last-name'],
          'city': this.baseInfo['city'],
          'houseNumber': this.baseInfo['house-number'],
          'apartmentNumber': this.baseInfo['apartment-number'],
          'street': this.baseInfo['street'],
        }
      })
    },
    removeCreditNumber(id) {
      if (confirm('האם אתה בטוח?')) {
        axios.get(`/${this.routeName}/removeCreditNumber/${id}`)
          .then((res) => {
            this.$emit('alert', 'success', 'Success');
            this.appendData()
          }).catch((err) => {
          this.$emit('alert', 'danger', err.response.data.data.error)
        })
      }
    },
    getCreditDetails(token) {

      let data = {
        token: token
      };

      axios.post(`orders/getOrderCreditNumber`, data)
        .then((res) => {
          const row = res.data.data.row.StatusCode;
          if (row == '000') {
            this.creditNumber = res.data.data.row.ResultData.CreditCardNumber;
            if (!this.creditShowVal) {
              this.creditShowVal = this.creditNumber;
            } else {
              this.creditShowVal = false;
            }
            this.tokenErrorMsg = "";
          } else {
            this.tokenErrorMsg = "שגיאת Token!";
          }
        }).catch((err) => {
        this.$emit('alert', 'danger', err.response.data.data.error)
      }).finally(() => {
        //  this.appendData()
      })

    },

    orderNewCredit(order_id) { //kobi

      let data = {
        order_id: parseInt(order_id)
      };

      axios.post(`orders/orderNewCredit`, data)
        .then((res) => {
          this.newCreditIframeUrl = res.data.data.iframe_url;

        }).catch((err) => {
        this.$emit('alert', 'danger', err.response.data.data.error)
      }).finally(() => {
        //  this.appendData()
      })

    },
    toDataURL(url) {
      return fetch(url).then((response) => {
        return response.blob();
      }).then(blob => {
        return URL.createObjectURL(blob);
      });
    },
    getCreditDecrypt(c_token, c_key) {
      let data = {
        card_owner_token: c_token,
        card_owner_key: c_key
      };

      axios.post(`orders/decryptCreditNumber`, data)
        .then((res) => {
          if (typeof (res.data.data.credit_number) !== 'undefined') {
            this.creditNumber = res.data.data.credit_number;
            if (!this.creditShowVal) {
              this.creditShowVal = this.creditNumber;
            } else {
              this.creditShowVal = false;
            }
            this.tokenErrorMsg = "";
          } else {
            this.tokenErrorMsg = "שגיאת Token!";
          }
        }).catch((err) => {
        this.$emit('alert', 'danger', err.response.data.data)
      }).finally(() => {
        //  this.appendData()
      })

    },
    changeMessageType(kind) {
      if (kind) {
        this.getDefaultMsg();
        this.selectedMessageType = kind;
        this.messages = this.allMessages[kind];
      }
    },

    async downloadPic(url) {
      const a = document.createElement("a");
      a.href = await this.toDataURL("http://api.hova.co.il/storage/web/public/2020/05/kaCLBmsPNM0PtnM8LUR0Vf6fkgHfY3mcwFaLLs6C.jpeg");
      a.download = "myImage.png";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);


      // fetch('http://localhost:8000/storage/2020/05/1tUTYmtJu6N4fo9XcSjcZsVrTAmuBQNCzGivlz2u.jpeg',{mode:"cors"},
      // {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': `Bearer ${localStorage.getItem('token')}`,
      //   }
      // }
      // )
      //   .then(res => res.blob())
      //   .then(blob => {
      //     const file = new File([blob], 'dot.png', {type:'image/png'});
      //     console.log(file);
      //   });

      /* axios({
         headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`},
         url: `http://localhost:8000/storage/2020/05/1tUTYmtJu6N4fo9XcSjcZsVrTAmuBQNCzGivlz2u.jpeg`,
         method: 'POST',
         responseType: 'blob',

       }).then((response) => {
         var fileURL = window.URL.createObjectURL(new Blob([response.data]));
         var fileLink = document.createElement('a');

         fileLink.href = fileURL;
         fileLink.setAttribute('download', 'file.pdf');
         document.body.appendChild(fileLink);

         fileLink.click();
       });*/
    },
    checkForHref(text) {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function (url) {
        return `<a href="${url}" target="_blank">${url}</a>`;
      });
    },
    checkStatus() {
      this.isChecked = !this.isChecked;
    },
    handleUserWhatsapp(phone, firstName, lastName) {
      if (!phone || !firstName || !lastName) {
        return;
      }
      if (lastName === 'leads') {
        let parts = splitName(firstName);

        firstName = parts[0];
        lastName = parts[1]; // כל השאר
      }

      checkWhatsappUser(phone, firstName, lastName)

    },
    openOrderReplicatesModal() {
      let element = this.$refs.orderReplicatesModal
      $(element).modal('show')
    },
    carMoreInfo(carNumber) {
      let url = '';
      switch (this.$store.getters.isHostName) {
        case 'localhost':
          url = "https://test.hova.co.il/car-finder/?car=" + carNumber;
          break;
        case 'front-stage.hova.co.il':
          url = "https://test.hova.co.il/car-finder/?car=" + carNumber;
          break;
        default:
          url = "https://hova.co.il/car-finder/?car=" + carNumber
      }
      window.open(url)
    },
    updateIsRenewal() {
      this.isRenewalOfExistingInsurance = !this.isRenewalOfExistingInsurance;

      let data = {
        isRenewalOfExistingInsurance: this.isRenewalOfExistingInsurance,
      };

      axios.post(`/${this.routeName}/updateRenewal/${this.$route.query.id}`, data)
        .then((res) => {
          if (res.data.data.success) {
            this.$emit('alert', 'success', 'Row updated')
          } else {
            this.$emit('alert', 'danger', 'Error')
          }
        })
        .catch((err) => {
        })

    },
    updateRoadServices() {
      let data = {
        roadServices: this.roadServicesIndex,
      };

      axios.post(`/${this.routeName}/updateRoadServices/${this.$route.query.id}`, data)
        .then((res) => {
          if (res.data.data.success) {
            this.$emit('alert', 'success', 'Row updated')
          } else {
            this.$emit('alert', 'danger', 'Error')
          }
        })
        .catch((err) => {
        })
    },
    checkFileType(file) {
      return file.includes('.pdf');

    },
    openPdfInNewTab(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },
    shouldShowInsuranceField(name) {
      const insuranceFields = ['insurance-1-year', 'insurance-2-year', 'insurance-3-year'];
      const insuranceBefore = this.baseInfo['insurance-before'];
      return !(String(insuranceBefore) !== '1' && insuranceFields.includes(name));
    },
    shouldHideField(name) {
      return false; // או תנאים אחרים – תלוי בך
    },
    onlyNumbersAndSlash(e) {
      const key = e.key;
      console.log('blaa')
      // אפשר מעבר עם backspace, tab, arrows וכו'
      if (
        ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(key)
      ) {
        return;
      }

      // רק מספרים
      if (!/[0-9]/.test(key)) {
        e.preventDefault();
        return;
      }

      // הגבלת אורך: 8 ספרות = DDMMYYYY
      const digits = e.target.value.replace(/\D/g, '');
      if (digits.length >= 8) {
        e.preventDefault();
      }

    },

    onInput(value) {

      let val = value;
      // אם כבר קיים פורמט DD/MM/YYYY – לא נגע
      if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val)) {
        return;
      }

      // שלב 1: שמור רק מספרים, מקסימום 8
      let digits = val.replace(/\D/g, '').slice(0, 8);
      console.log(digits);
      // שלב 2: הרכב פורמט
      let formatted = '';
      if (digits.length >= 5) {
        const day = parseInt(digits.slice(0, 2)).toString();
        const month = parseInt(digits.slice(2, 4)).toString();
        const year = digits.slice(4);
        formatted = `${day}/${month}/${year}`;
      } else if (digits.length >= 3) {
        const day = parseInt(digits.slice(0, 2)).toString();
        const month = parseInt(digits.slice(2)).toString();
        formatted = `${day}/${month}`;
      } else {
        formatted = digits;
      }

      // שלב 3: פלט אחיד
      this.$emit('input', formatted);

      // שלב 4: בדיקת תקינות אם באורך מלא
      if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(formatted)) {
        const [d, m, y] = formatted.split('/').map(Number);
        const date = new Date(y, m - 1, d);
        const isValid = date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d;

        console.log(`${isValid ? '✅ תאריך תקין' : '❌ תאריך שגוי'}: ${formatted}`);
      }

      this.baseInfo['insurance-date-start'] = formatted;
    },

    showProductHistory(row, k) {
      if (row) {
        this.productsHistoryShowId = row.id
        let element = this.$refs.productHistoryModal
        $(element).modal('show')

      }

    },
    getTotalPrice() {
      if (!this.products || !Array.isArray(this.products)) return 0;
      const activeProducts = this.products.filter(product => product.statusId === 1);
      return activeProducts.reduce((sum, product) => {
        return sum + (parseFloat(product.price) || 0);
      }, 0);
    },
    getAverageDeductible() {
      if (!this.products || !Array.isArray(this.products)) return 0;
      const activeProducts = this.products.filter(product => product.statusId === 1);
      const productsWithDeductible = activeProducts.filter(product => product.deductible);
      if (productsWithDeductible.length === 0) return 0;
      const total = productsWithDeductible.reduce((sum, product) => {
        return sum + (parseFloat(product.deductible) || 0);
      }, 0);
      return Math.round(total / productsWithDeductible.length);
    },
    getAverageDebtSettlement() {
      if (!this.products || !Array.isArray(this.products)) return 0;
      const activeProducts = this.products.filter(product => product.statusId === 1);
      const productsWithDebtSettlement = activeProducts.filter(product => product.debtSettlement);
      if (productsWithDebtSettlement.length === 0) return 0;
      const total = productsWithDebtSettlement.reduce((sum, product) => {
        return sum + (parseFloat(product.debtSettlement) || 0);
      }, 0);
      return Math.round(total / productsWithDebtSettlement.length);
    },
    getAverageZadGimelRes() {
      if (!this.products || !Array.isArray(this.products)) return 0;
      const activeProducts = this.products.filter(product => product.statusId === 1);
      const productsWithZadGimelRes = activeProducts.filter(product => product.zadGimelRes);
      if (productsWithZadGimelRes.length === 0) return 0;
      const total = productsWithZadGimelRes.reduce((sum, product) => {
        return sum + (parseFloat(product.zadGimelRes) || 0);
      }, 0);
      return Math.round(total / productsWithZadGimelRes.length);
    },
    getMonthlyPayment(product) {
      if (!product.price || !product.numberOfPayment) return '';
      const price = parseFloat(product.price) || 0;
      const payments = parseInt(product.numberOfPayment) || 1;
      if (payments <= 0) return '';
      const monthlyPayment = price / payments;
      return `תשלום חודשי: ${Math.round(monthlyPayment)} ₪ (${price} ÷ ${payments})`;
    },
    openDraftOrderModal() {
      let element = this.$refs.draftOrderModel.$el
      $(element).modal('show')
    },
    async transferToOrders(action) {
      try {
        const response = await axios.post(`/renewals/transferToOrders`, {
          id: this.$route.query.id,
          renewalId: this.baseInfo['renewalId'],
          action: action,
        });

        if (response.data.success) {
          if (action === 'transfer') {
            // Remove source parameter and stay in orders view
            let newRoute = {...this.$route.query};
            delete newRoute.source;
            await this.$router.push({query: newRoute});
          } else {
            // Redirect to renewals view
            await this.$router.push('/renewals');
          }
          this.$emit('alert', 'success', 'ההזמנה עודכנה בהצלחה');
        } else {
          this.$emit('alert', 'danger', 'שגיאה בעדכון ההזמנה');
        }
      } catch (error) {
        console.error('Error transferring to orders:', error);
        this.$emit('alert', 'danger', 'שגיאה בעדכון הסטטוס');
      }
    },
    updateRenewalStatus() {
      let data = {
        statusId: parseInt(this.$refs.renewalStatus.value),
        renewalId: this.baseInfo['renewalId']
      };
      axios.post(`/renewals/updateStatus`, data)
        .then((res) => {
          console.log('updateRenewalStatus')
          console.log(res)
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        });

    },
    updateLogo() {
      if (!this.baseInfo || !this.baseInfo['modeSource']) {
        return;
      }
      this.$nextTick(() => {
        const logoImg = document.querySelector('.crm-logo img');
        if (logoImg) {
          const modeSource = this.baseInfo['modeSource'];
          if (modeSource === 'hova') {
            logoImg.src = require('@/assets/hovaLogo.svg');
          } else if (modeSource === '10b') {
            logoImg.src = require('@/assets/10bLogo.svg');
          }
          logoImg.style.width = '100px';
        }
      });
    }
  }
}

const main = [
  'first-name',
  'last-name',
  'status',
  'id',
  'insurance-date-finish',
  'insurance-date-start',
  'ins_order',
  'source'

]
const carNew = [

  {
    name: 'vehicle-manufacturer',
    type: 'text',
    editable: true,
  },
  {
    name: 'vehicle-brand',
    type: 'text',
    editable: true,
  },
   {
    name: 'vehicle-year',
    type: 'text',
    editable: true,
  },
  {
    name: 'vehicle-sub-brand',
    type: 'text',
    editable: true,
  },
  {
    name: 'engine_capacity',
    type: 'text',
    editable: true,
  },
   {
    name: 'ownership',
    type: 'text',
    editable: true,
    readOnly: false,
  },
  {
    name: 'carType',
    type: 'text',
    editable: true,
  },
  {
    name: 'esp',
    type: 'select',
    options: [
      {key: '1', value: 'כן'},
      {key: '0', value: 'לא'},
    ],
    editable: false,
    readOnly: false,
  },
  {
    name: 'deviation-system',
    type: 'select',
    options: [
      {key: '1', value: 'כן'},
      {key: '2', value: 'לא'},
    ],
    editable: false,
    readOnly: false,
  },
  {
    name: 'keeping-distance-system',
    type: 'select',
    options: [
      {key: '1', value: 'כן'},
      {key: '2', value: 'לא'},
    ],
    editable: false,
    readOnly: false,
  },
  {
    name: 'levi-code',
    type: 'text',
    editable: true,
  },
   {
    name: 'vehicle_search_method',
    type: 'text',
    editable: false,
  },


]
const car = [
  'ownership',
  'vehicle-manufacturer',
  'vehicle-brand',
  'vehicle-sub-brand',
  'vehicle-year',
  'engine_capacity',
  'carType',
  'esp',
  'deviation-system',
  'keeping-distance-system',
  // 'license-number-go',
  'levi-code',

  // 'license-number',
  // 'gearBox',
  // 'levelOfProtection',
]
const carMakif = [

  'vehicle-manufacturer',
  'vehicle-brand',
  'vehicle-year',
  'vehicle-sub-brand',
  'engine_capacity',
  'ownership',
  'carType',
  'esp',
  'levi-code',
  'keeping-distance-system',
  'deviation-system',
  'mortgaged',
  // 'license-number-go',
  'insurance_protection_text',
  'vehicle_search_method',

  // 'license-number',
  // 'gearBox',
  // 'levelOfProtection',
]
const driverLawNew = [

  {
    name: 'drive-allowed-number',
    type: 'text',
    editable: true,
  },
  {
    name: 'youngest-driver',
    type: 'text',
    editable: true,
  },
  {
    name: 'lowest-seniority',
    type: 'text',
    editable: true,
  },
  {
    name: 'gender',
    type: 'select',
    options: [
      {key: '1', value: 'זכר'},
      {key: '2', value: 'נקבה'},
    ],
    editable: true,
    readOnly: false
  },
  {
    name: 'license-suspensions',
    type: 'text',
    editable: true,
    readOnly: false
  },
  {
    name: 'body-claims',
    type: 'text',
    editable: true,
  },
  {
    name: 'drive-on-saturday',
    type: 'select',
    options: [
      {key: '1', value: 'כן'},
      {key: '2', value: 'לא'},
    ],
    editable: true,
    readOnly: false,
  },

]

const driverLaw = [
  'drive-allowed-number',
  'youngest-driver',
  'lowest-seniority',
  'gender',
  'license-suspensions',
  'body-claims',
  'drive-on-saturday',
]

const driverHistoryNew = [

  {
    name: 'insurance-before',
    type: 'select',
    options: [
      {key: '1', value: 'כן'},
      {key: '2', value: 'לא'},
    ],
    editable: true,
    readOnly: false
  },
  {
    name: 'insurance-1-year',
    type: 'select',
    options: [
      {key: '1', value: 'מקיף'},
      {key: '2', value: 'צד ג'},
      {key: '3', value: 'לא היה'},
    ],
    editable: true,
    readOnly: false
  },
  {
    name: 'insurance-2-year',
    type: 'select',
    options: [
      {key: '1', value: 'מקיף'},
      {key: '2', value: 'צד ג'},
      {key: '3', value: 'לא היה'},
    ],
    editable: true,
    readOnly: false
  },
  {
    name: 'insurance-3-year',
    type: 'select',
    options: [
      {key: '1', value: 'מקיף'},
      {key: '2', value: 'צד ג'},
      {key: '3', value: 'לא היה'},
    ],
    editable: true,
    readOnly: false
  },
  {
    name: 'ownership-date',
    type: 'select',
    options: [
      {key: '1', value: 'מתחת לחודש'},
      {key: '2', value: 'מעל לחודש'},
    ],
    editable: true,
    readOnly: false
  },
  {
    name: 'ownership-under-year',
    type: 'text',
    editable: true,
    readOnly: false
  },
  {
    name: 'law-suites-3-year',
    type: 'select',
    options: [
      {key: '1', value: 'כן'},
      {key: '2', value: 'לא'},
    ],
    editable: true,
    readOnly: false
  },

]
const driverHistory = [
  'insurance-before',
  'insurance-1-year',
  'insurance-2-year',
  'insurance-3-year',
  //'statusHistoryInsurance',
  'ownership-date',
  'ownership-under-year',
  'law-suites-3-year',
]
const driver = [
  'first-name',
  'last-name',
  'customerId',
  'policeOwnerGender',
  'mobile-phone-number',
  'additional-phone-number',
  'email',
  'city',
  'street',
  'house-number',
  'apartment-number',
  'license-year',
  'identical-number',
  'birthday-date'
  // 'tac',
  // 'surfingSource',
];
const driver_1 = [
  'firstDriverFirstName',
  'firstDriverGender',
  'firstDriverLastName',
  'firstDriverLicenceYear',
  'firstDriverTz',
  'firstDriverYearBirth',
];
const driver_2 = [
  'secondDriverFirstName',
  'secondDriverGender',
  'secondDriverLastName',
  'secondDriverLicenceYear',
  'secondDriverTz',
  'secondDriverYearBirth',
];
const driver_3 = [
  'thirdDriverFirstName',
  'thirdDriverGender',
  'thirdDriverLastName',
  'thirdDriverLicenceYear',
  'thirdDriverTz',
  'thirdDriverYearBirth',
]
const creditCard = [
  'cardholder-name',
  'cardholder-id',
  'card-number',
  'cardholder-year',
  'cardholder-month',
  'cardholder_phone'
]
</script>
